import React, { useState, useRef, useEffect, useMemo } from "react"
import {
  CardBody,
  Col,
  Container,
  Row,
  DropdownItem,
  DropdownMenu,
  InputGroup,
  Input,
  InputGroupText,
} from "reactstrap"
import { Dropdown } from "primereact/dropdown"
import { TabView, TabPanel } from "primereact/tabview"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { FilterMatchMode } from "primereact/api"
// import { DataTable } from "primereact/datatable"\
import { Column } from "primereact/column"
import { InputText } from "primereact/inputtext"
import { Button } from "primereact/button"
import { Sidebar } from "primereact/sidebar"
import { InputNumber } from "primereact/inputnumber"
import { InputTextarea } from "primereact/inputtextarea"
import { CascadeSelect } from "primereact/cascadeselect"
import { SelectButton } from "primereact/selectbutton"
import * as XLSX from "xlsx"
import jsPDF from "jspdf"
import { MultiSelect } from "primereact/multiselect"
import "jspdf-autotable"
import { Dialog } from "primereact/dialog"
import Modal from "react-bootstrap/Modal"
import { useForm } from "react-hook-form"
import { ChevronDownIcon } from "primereact/icons/chevrondown"
import { ChevronRightIcon } from "primereact/icons/chevronright"
import axios from "axios"
import { TreeSelect } from "primereact/treeselect"
import { Password } from "primereact/password"

import { Accordion, AccordionTab } from "primereact/accordion"
import { Badge } from "primereact/badge"
import { TreeTable } from "primereact/treetable"
import { Calendar } from "primereact/calendar"
import { Editor } from "primereact/editor"
import { Card } from "primereact/card"
import { ProgressSpinner } from "primereact/progressspinner"
import OrgTableShimmer from "ATSComponents/Common/OrgTableShimmer"
import { Checkbox } from "primereact/checkbox"
import { Chips } from "primereact/chips"
import moment from "moment"

import { Tooltip } from "primereact/tooltip"
import SubmitContacttoCandidate from "./SubmitContacttoCandidate"
import { setContactSidebarVisible } from "store/actions"

import AddJob from "./AddJob"
import MoreACcontacts from "./MoreACcontacts"
import NotesContact1 from "ATSComponents/Common/NotesContact1"
import NotesContact from "ATSComponents/Common/NotesContact"
import { triggerAlert, ConfirmationAlert } from "utils/CommonFunctions"
import { Message } from "primereact/message"
import EmailContacts from "./EmailContacts"
import { useSelector, useDispatch } from "react-redux"
import { setPageData } from "store/actions"
import { Toast } from "primereact/toast"
import LinkContactJob1 from "ATSComponents/Common/LinkContactJob1"
import LinkCandidatesPopup1 from "ATSComponents/Common/LinkCandidatesPopup1"
import { ContextMenu } from "primereact/contextmenu"

//lokesh permisions
import { menuIdData } from "../../utils/Constants"
import { get_user_menu_permission } from "../../utils/CommonFunctions"
import { ClimbingBoxLoader } from "react-spinners"
import { color } from "echarts"
import { get } from "store"
import CompanySelector from "ATSComponents/Common/CompanySelector"
import { FaTimes } from "react-icons/fa"
import DataTable from "react-data-table-component"



const ContactsAllActive = ({ type, param }) => {
  //states for permissions by lokesh
  const [statusOptions, setStatusOptions] = useState([
    { label: "Active", value: "Active" },
    { label: "InActive", value: "InActive" },
    { label: "DND (Do Not Disturb)", value: "DND (Do Not Disturb)" },
    { label: "Blacklisted", value: "Blacklisted" },
  ]);
  const [addPermission, setAddPermission] = useState(false)
  const [editPermission, setEditPermission] = useState(false)
  const [deletePermission, setDeletePermission] = useState(false)
  const [viewPermission, setViewPermission] = useState(false)
  const [selectedStatus, setSelectedStatus] = useState(statusOptions[0].value);
const renderCell = (value, columnTitle) => {
  if (!value) return "--";

  return (
    <span
      className="table-cell-ellipsis"
      title={`${value}`}
    >
      {value}
    </span>
  );
};
const columns = [
  { field: "employee_code", header: "Employee Code" },
  { field: "first_name", header: "First Name"},
  // { field: "last_name", header: "Last Name"},
  {
    field: "last_name",
    header: "Last Name",
    body: (row) =>
      [row.middle_name, row.last_name]
        .filter(Boolean)
        .join(" ")
  },

  { field: "email", header: "Email"},
  { field: "role_name", header: "Role" },
  { field: "primary_manager_name", header: "Reporting Manager" },
  { field: "phone_number", header: "Mobile"},
  { field: "department_name", header: "Department"},
  { field: "designation_name", header: "Designation" },
  { field: "status", header: "Status" }
];


  // useEffect(() => {
  //   if (type === "my-active") {
  //     const menu_id = menuIdData?.MyActiveContacts
  //     setAddPermission(get_user_menu_permission(menu_id, "add"))
  //     setEditPermission(get_user_menu_permission(menu_id, "edit"))
  //     setDeletePermission(get_user_menu_permission(menu_id, "delete"))
  //     setViewPermission(get_user_menu_permission(menu_id, "view"))
  //   } else if (param === "archived_only=true") {
  //     const menu_id = menuIdData?.ArchivedContacts
  //     setAddPermission(get_user_menu_permission(menu_id, "add"))
  //     setEditPermission(get_user_menu_permission(menu_id, "edit"))
  //     setDeletePermission(get_user_menu_permission(menu_id, "delete"))
  //     setViewPermission(get_user_menu_permission(menu_id, "view"))
  //   } else if (type === "duplicate-companies") {
  //     const menu_id = menuIdData?.ContactsDuplicateList
  //     setAddPermission(get_user_menu_permission(menu_id, "add"))
  //     setEditPermission(get_user_menu_permission(menu_id, "edit"))
  //     setDeletePermission(get_user_menu_permission(menu_id, "delete"))
  //     setViewPermission(get_user_menu_permission(menu_id, "view"))
  //   } else if (type === "task-list") {
  //     const menu_id = menuIdData?.ContactsTaskList
  //     setAddPermission(get_user_menu_permission(menu_id, "add"))
  //     setEditPermission(get_user_menu_permission(menu_id, "edit"))
  //     setDeletePermission(get_user_menu_permission(menu_id, "delete"))
  //     setViewPermission(get_user_menu_permission(menu_id, "view"))
  //   } else if (type === "activity-log") {
  //     const menu_id = menuIdData?.ContactsActivityLog
  //     setAddPermission(get_user_menu_permission(menu_id, "add"))
  //     setEditPermission(get_user_menu_permission(menu_id, "edit"))
  //     setDeletePermission(get_user_menu_permission(menu_id, "delete"))
  //     setViewPermission(get_user_menu_permission(menu_id, "view"))
  //   } else {
  //     const menu_id = menuIdData?.AllActiveContacts
  //     setAddPermission(get_user_menu_permission(menu_id, "add"))
  //     setEditPermission(get_user_menu_permission(menu_id, "edit"))
  //     setDeletePermission(get_user_menu_permission(menu_id, "delete"))
  //     setViewPermission(get_user_menu_permission(menu_id, "view"))
  //   }
  // }, [])

  const toast = useRef(null)
  const { first, rows, totalRecords } = useSelector(
    state => state.calendar.pagination
  )

  const dispatch = useDispatch()

  const [isEdited, setisEdited] = useState(false)
  const [editId, setEditId] = useState(null)
  const [visibleViewRight, setVisibleViewRight] = useState(false)
  // const [lazyParams, setLazyParams] = useState({ page: 0, rows: 10 });
  // const [totalRecords, setTotalRecords] = useState(0);
  // sms

  const [selectedSmsOption, setSelectedSmsOption] = useState(null)
  const smsOptions = [
    { label: "Selected", icon: "pi pi-check-circle" },
    { label: "Searched", icon: "pi pi-search" },
    { label: "All", icon: "pi pi-inbox" },
  ]

  // const labels = [
  //   { name: "Work from Office (WFO)", code: "WORK" },
  //   { name: "Work from Home (WFH)", code: "HOME" },
  //   { name: "Work from Remote (WFR)", code: "REMOTE" },
  // ]

  const selectedSmsTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <i className={`${option.icon} mr-2`}></i>
          <div>{option.label}</div>
        </div>
      )
    }
    return (
      <div className="flex align-items-center">
        <i className="pi pi-comment mr-2"></i>
        <span>{props.placeholder}</span>
      </div>
    )
  }

  const smsOptionTemplate = option => {
    return (
      <div className="flex align-items-center">
        <i className={`${option.icon} mr-2`}></i>
        <div>{option.label}</div>
      </div>
    )
  }

  //schedule
  const [scheduleOptions, setScheduleOptions] = useState([])

  const getSchedule = async () => {
    ////console.log("ssssss", scheduleOptions)
    try {
      const response = await axios.get(`/api/v1/get-all-schedule-type/`)
      // Ensure the response data is correctly structured
      const trans = response.data.results?.map(item => ({
        id: item?.id,
        label: item?.schedule_type,
        description: item?.description,
        type: item?.type,
      }))
      setScheduleOptions(trans)
    } catch (error) {
      //console.error("Error fetching schedule types:", error);
    }
  }

  const selectedScheduleTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <i className={`${option.icon} mr-2`} />
          <div>{option.label}</div>
        </div>
      )
    }
    return (
      <div className="flex align-items-center">
        <i className="pi pi-calendar mr-2" />{" "}
        {/* Default icon for placeholder */}
        <span>{props.placeholder}</span>
      </div>
    )
  }

  const scheduleOptionTemplate = option => {
    return (
      <div className="flex align-items-center">
        <i className={`${option.icon} mr-2`} />
        <div>{option.label}</div>
      </div>
    )
  }

  // more

  const [selectedOption, setSelectedOption] = useState(null)
  const options = []

  const selectedOptionTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <i className={`${option.icon} mr-2`}></i>
          <div>{option.label}</div>
        </div>
      )
    }
    return (
      <div className="flex align-items-center">
        <i className="pi pi-cog mr-2"></i>
        <span>{props.placeholder}</span>
      </div>
    )
  }

  const optionTemplate = option => {
    return (
      <div className="flex align-items-center">
        <i className={`${option.icon} mr-2`}></i>
        <div>{option.label}</div>
      </div>
    )
  }

  const [activeIndex, setActiveIndex] = useState(0)

  const onTabClose = index => {
    const updatedTabs = tabs?.filter((_, i) => i !== index)
    setTabs(updatedTabs)

    if (activeIndex === index) {
      setActiveIndex(prev => Math.max(0, prev - 1))
    } else if (activeIndex > index) {
      setActiveIndex(prev => prev - 1)
    }
  }

  document.title = "ATS - All Employees"

  const [selectedCountry, setSelectedCountry] = useState(null)
  const [selectedState, setSelectedState] = useState(null)
  const [selectedCity, setSelectedCity] = useState(null)
  const [customers, setCustomers] = useState([])
  const dt = useRef(null)
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    first_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    last_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    company_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    job_title: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    email: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    phone_number: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    AssociatedContacts: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    department_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    full_address: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    notes: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    category_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    groups_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    user_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    created_by_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    last_activity_type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    last_activity_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    created_at: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    updated_at: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  })

  const [loading, setLoading] = useState(false)
  const [selectedCustomers, setSelectedCustomers] = useState([])
  const [pageState, setPageState] = useState({ first: 0, rows: 10 })
  const [selectedCompany, setSelectedCompany] = useState(null)
  const [companies, setcompanies] = useState([])
  const [showIconsSelect, setShowIconsSelect] = useState(false)
  const [showesitSelect, setshowesitSelect] = useState(true)
  const [selectedEmployees, setselectedEmployees] = useState(0)
  const [showesitSelecticon, setshowesitSelecticon] = useState(false)
  const [contactname, setcontactname] = useState([])
  const [searchQuery, setSearchQuery] = useState("")

  const contactSidebarVisible = useSelector((state) => state.calendar.contactSidebarVisible);

  const onSelectionChange = e => {
    const selected = e.value || []
    setSelectedCustomers(selected)
    setcontactvalu(selected)
    setselectedEmployees(selected.length)
    const selectednames = selected?.map(candidate => candidate?.first_name)
    setcontactname(selectednames)

    // Update the icon display state
    if (selected.length === 1) {
      setShowIconsSelect(false) // Show all icons
      setshowesitSelect(false)
      setshowesitSelecticon(true)
    } else if (selected.length > 1) {
      setShowIconsSelect(true)
      setshowesitSelect(false)
      setshowesitSelecticon(true)
    } else {
      setShowIconsSelect(false)
      setshowesitSelect(true)
      setshowesitSelecticon(false)
    }
  }

  const onPage = e => {
    setPageState({
      first: e.first,
      rows: e.rows,
    })
  }
  const onRowReorder = e => {
    setCustomers(e.value)
  }

  const firstnameEditor = props => {
    return (
      <InputText
        value={props.value}
        onChange={e => props.editorCallback(e.target.value)}
      />
    )
  }
  const firstnameEditor1 = props => {
    return (
      <InputText
        value={props.value}
        onChange={e => props.editorCallback(e.target.value)}
      />
    )
  }

  const onCellEditComplete = e => {
    const { rowData, newValue, field } = e
    if (rowData[field] !== newValue) {
      const updatedCustomers = customers?.map(customer =>
        customer.id === rowData.id
          ? { ...customer, [field]: newValue }
          : customer
      )
      setCustomers(updatedCustomers)
      localStorage.setItem("customers", JSON.stringify(updatedCustomers))
    }
  }

  // const header = renderHeader();
  const [visible, setVisible] = useState(false) // State to control the visibility of the modal
  const [visibleRight, setVisibleRight] = useState(false)
  const [addStates, setAddStates] = useState([])
  const [addCities, setaddCities] = useState([])
  const [addCountries, setAddCountries] = useState([])

  const getaddCountries = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-countries/`, {})
      const transformedData = response.data.results?.map(Countries => ({
        name: Countries?.name,
        id: Countries?.country_id,
      }))
      setAddCountries(transformedData)
    } catch (error) { }
  }

  const getstateitems = async countryId => {
    try {
      const response = await axios.get(
        `/api/v1/get-all-states/?country_id=${countryId}`,
        {}
      )

      // Transform data if needed to match the Dropdown format
      const transformedData = response.data.results?.map(state => ({
        name: state?.name,
        id: state?.state_id,
      }))
      setAddStates(transformedData)
    } catch (error) {
      //console.error('Error fetching states:', error);
    }
  }
  const getcity = async stateId => {
    try {
      const response = await axios.get(
        `/api/v1/get-all-cities/?state_id=${stateId}`,
        {}
      )
      // Transform data if needed to match the Dropdown format
      const transformedData = response.data.results?.map(city => ({
        name: city?.name,
        id: city?.city_id,
      }))
      setaddCities(transformedData)
    } catch (error) {
      //console.error('Error fetching states:', error);
    }
  }
  // useEffect(() => {
  //   getSchedule()
  // }, [])

  useEffect(() => {
    if (selectedCountry) {
      getstateitems(selectedCountry.id)
    }
  }, [selectedCountry])

  useEffect(() => {
    if (selectedState) {
      getcity(selectedState.id)
    }
  }, [selectedState])

  /////////////////////////////////////////////

  const {
    register,
    handleSubmit,
    reset,
    trigger,
    clearErrors,
    formState: { errors },
    setValue,
    getValues,
  } = useForm()
  const [compamyitem, setcompamyitem] = useState([])
  const [departitems, setdepartitems] = useState([])
  const [address, setAddress] = useState("")
  const [selectedLabel, setSelectedLabel] = useState(null)
  const [postalCode, setPostalCode] = useState("")
  const [street1, setStreet1] = useState("")
  const [street2, setStreet2] = useState("")

  const [dataLoading, setDataLoading] = useState(false)

  useEffect(() => {
    const addressParts = [
      street1 || "",
      street2 || "",
      selectedCity?.name || "",
      selectedState?.name || "",
      selectedCountry?.name || "",
      postalCode || "",
      selectedLabel?.name || "",
    ].filter(part => part && part.trim() !== "") // Remove empty or whitespace-only values

    // Join parts with commas except for the last one
    const formattedAddress = addressParts
      ?.map((part, index) =>
        index < addressParts.length - 1 ? `${part},` : part
      )
      .join("\n")

    setAddress(formattedAddress)
  }, [
    street1,
    street2,
    selectedCity,
    selectedState,
    selectedCountry,
    postalCode,
    selectedLabel,
  ])

  const userInfos = JSON.parse(sessionStorage.getItem("atsuser-info"));
  const intialcompanyId = userInfos.user_details.companies_data[0].company_id;
  const [companyId, setCompanyId] = useState(intialcompanyId);

  // const getallactivecontacts = async (
  //   page,
  //   query,
  //   selectedType = "",
  //   param = "",
  //   statusValue,
  //   companyId
  // ) => {
  //   setDataLoading(true)
  //   try {
  //     const statusToUse = statusValue || selectedStatus;
  //     const endpoint =
  //       // selectedType === "activity-log"
  //         // ? `/api/v1/activity-log/?module=Contact&page=${page}&size=${rows}&status=${statusToUse}`
  //         // : selectedType === "task-list"
  //           // ? `/api/v1/events/task-list/?module=Contact&page=${page}&size=${rows}&status=${statusToUse}`
  //           `/api/v1/contacts/?page=${page}&size=${rows}&company_id=${companyId}`

  //     const response = await axios.get(endpoint)
  //     if (response.status === 200) {
  //       if (response.data.results && response.data.results.length > 0) {
  //         const cols = Object.keys(response.data.results[0])?.map(key => ({
  //           field: key,
  //           header: key.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase()),
  //         }))
  //       }
  //       dispatch(
  //         setPageData({
  //           first: (page - 1) * rows,
  //           rows: rows || 10,
  //           totalRecords: response.data.count,
  //         })
  //       )
  //       setSelectedCustomers([])
  //       setCustomers(response.data.results || [])
  //     // console.info("Fetched contacts:", response.data.results);
  //       setDataLoading(false)
  //       //setTotalRecords(response.data.count || 0);
  //     } else {
  //       setCustomers([])
  //     }
  //   } catch (error) {
  //     console.error("Error fetching contacts:", error)
  //     setDataLoading(false)
  //   } finally {
  //     setDataLoading(false)
  //   }
  // }



  // useEffect(() => {
  //   const page = Math.floor(first / rows) + 1
  //   getallactivecontacts(page,companyId)
  // }, [searchQuery, first, rows, selectedStatus,companyId])



const handleCompanyChange = (company) => {
  if (company?.company_id) {
    setCompanyId(company.company_id);
    setCurrentPage(1);
    setRowsPerPage(10); // 👈 default back to 10
  }
};


//  const onPageChange = (e) => {
//   const page = Math.floor(e.first / e.rows) + 1

//   setLazyParamsContacts({
//     first: e.first,
//     rows: e.rows,
//     page: page,
//   })
// }


  const [disable, setDisable] = useState(false)

  const [relatedPerson, setRelatedPerson] = useState([])

  const getRelatedPersons = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-hiring-managers/`)
      setRelatedPerson(response.data.results)
    } catch (error) {
      // console.log("Failed to fetch related persons", error);
    }
  }

  const [showPassword, setShowPassword] = useState(false)

  // const onsubmitEdit = async data => {
  //   setLoading(true)
  //   setDisable(true)
  //   let req = {}

  //   if (data.jobtitle) {
  //     req.job_title = data.jobtitle
  //   }

  //   if (selectedCompany) {
  //     req.company = selectedCompany.id
  //   }

  //   if (data.Related) {
  //     req.related_person = data.Related
  //   }

  //   if (data.department) {
  //     req.department = data.department
  //   }

  //   if (data.firstname) {
  //     req.first_name = data.firstname
  //   }
  //   // if (data.middlename) {
  //   //   req.middle_name = data.middlename;
  //   // }

  //   if (data.lastname) {
  //     req.last_name = data.lastname
  //   }
  //   if (data.username) {
  //     req.user_id = data.username
  //   }
  //   if (data.password) {
  //     req.password = data.password
  //   }

  //   if (data.personal_email) {
  //     req.email = data.personal_email
  //   }

  //   if (data.Phone) {
  //     req.phone_number = data.Phone
  //   }
  //   if (selectedCategoryKey) {
  //     req.category = selectedCategoryKey
  //   }
  //   if (selectedGroupKey) {
  //     req.group = selectedGroupKey
  //   }

  //   if (street1) {
  //     req.street_address = street1
  //   }
  //   if (street2) {
  //     req.street_address_line_2 = street2
  //   }
  //   if (selectedCity) {
  //     req.city = selectedCity.id
  //     req.city_name = selectedCity.name
  //   }
  //   if (selectedState) {
  //     req.state = selectedState.id
  //     req.state_name = selectedState.name
  //   }
  //   if (postalCode) {
  //     req.pincode = postalCode
  //   }
  //   if (selectedCountry) {
  //     req.country = selectedCountry.id
  //     req.country_name = selectedCountry.name
  //   }

  //   if (selectedLabel) {
  //     req.label = selectedLabel?.id
  //   }
  //   req.private = data.private ? "true" : "false"

  //   try {
  //     if (!isEdited) {
  //       // Create new contact
  //       const response = await axios.post(`/api/v1/contacts/`, req)
  //       triggerAlert("success", "Success", "Contact created successfully!")
  //       if (response.data) {
  //         const page = Math.floor(first / rows) + 1
  //         getallactivecontacts(page, type, param)
  //         dispatch(setContactSidebarVisible(false))
  //         setSelectedCustomers([])
  //         setshowesitSelecticon(false)
  //         reset()
  //       }
  //     } else {
  //       // Update existing contact
  //       const response = await axios.patch(`/api/v1/contacts/${editId}/`, req)
  //       triggerAlert("error", "Error", "Failed to created contact")
  //       if (response.data) {
  //         const page = Math.floor(first / rows) + 1
  //         getallactivecontacts(page, type, param)
  //         dispatch(setContactSidebarVisible(false))
  //         setshowesitSelect(true)
  //         setshowesitSelecticon(false)
  //         setSelectedCustomers([])
  //         reset()
  //       }
  //     }
  //   } catch (error) {
  //     //console.error('Error submitting form:', error);
  //     triggerAlert(
  //       "error",
  //       "Error",
  //       error.response?.data?.error || "Failed to created contact"
  //     )
  //     dispatch(setContactSidebarVisible(false))
  //     reset()
  //   } finally {
  //     setLoading(false)
  //     setDisable(false)
  //   }
  // }

  const getCompanydata = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-companies/`, {})
      // if (response.data) {
      //     let results = response.data.results;
      //     setcompanies(results);
      // }
      const transformedData = response.data.results?.map(company => ({
        name: company?.company_name,
        id: company?.company_id,
      }))
      setcompanies(transformedData)
    } catch (error) { }
  }
  // const getDepartments = async () => {
  //   try {
  //     const response = await axios.get(`/api/v1/departments/`, {})
  //     if (response.data) {
  //       let results = response.data.results
  //       setdepartitems(results)
  //     }
  //   } catch (error) { }
  // }

  const [uniqueUserId, setUniqueUserId] = useState("")
  useEffect(() => {
    const userInfo = JSON.parse(sessionStorage.getItem("atsuser-info"))
    if (userInfo && userInfo.user_details) {
      setUniqueUserId(userInfo.user_details.unique_user_id)
    }
  }, [])

  // useEffect(() => {
  //   getCompanydata()
  //   getDepartments()
  //   // fetchRelatedPerson()
  //   // getcontact()

  // }, []);
  const [deleteRowId, setDeleteRowID] = useState(null) // end date value
  const [smShow, setSmShow] = useState(false)
  const [successAlert, setSuccessAlert] = useState(false)

  // const deleteHandler = async () => {
  //   let id = deleteRowId
  //   try {
  //     await axios.delete(`/api/v1/contacts/${id}/`)
  //     setSmShow(false)
  //     setshowesitSelecticon(false)
  //     setshowesitSelect(true)
  //     setShowIconsSelect(false)
  //     setSelectedCustomers([])
  //     setselectedEmployees(0)
  //     setSuccessAlert(true)
  //     const page = Math.floor(first / rows) + 1
  //     await getallactivecontacts(page, rows, type, param)
  //   } catch (error) {
  //     console.error("Error deleting contact:", error)
  //     // Handle error appropriately, such as showing an error message to the user
  //   }
  // }

  const getCandidateIds = () => {
    const selectedIds = selectedCustomers?.map(candidate => candidate?.id)
    setDeleteRowID(selectedIds)
    setSmShow(true)
  }
  const [city, setCity] = useState("")
  const [fullName, setFullName] = useState("")
  const [jobTitle, setJobTitle] = useState("")
  const [company, setCompany] = useState("")
  const [userIds, setUserIds] = useState("")
  const [availabilityDate1, setavailabilityDate1] = useState("")
  const [phoneNumber, setPhoneNumber] = useState("")
  const [workEmail, setWorkEmail] = useState("")

  const [description, setDescription] = useState("")
  const [primarySkillsvalu, setprimarySkillsvalu] = useState([])
  const [primarySkills, setPrimarySkills] = useState(null)
  const [relocation, setRelocation] = useState(null)

  const getprimary = async () => {
    try {
      const response = await axios.get(`/api/v1/skills/`, {})
      if (response.data && response.data.results) {
        const treeData = response.data.results

        setprimarySkillsvalu(treeData)
      }
    } catch (error) { }
  }

  //meghana
  const [treeCategories, setTreeCategories] = useState([])
  const [selectedCategoryKey, setSelectedCategoryKey] = useState(null)

  const transformCategoriesToTree = categories => {
    const buildTree = category => ({
      key: category.category_id,
      label: category.name,
      data: category,
      children: category.subcategories
        ? category.subcategories?.map(buildTree)
        : [],
    })

    return categories?.map(buildTree)
  }

  // Transform groups to tree structure
  const transformGroupsToTree = groups => {
    const buildTree = group => ({
      key: group.group_id,
      label: group.name,
      data: group,
      children: group.subgroups ? group.subgroups?.map(buildTree) : [],
    })

    return groups?.map(buildTree)
  }

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-categories/`)
      if (response.data && response.data.results) {
        const treeData = transformCategoriesToTree(response.data.results)
        setTreeCategories(treeData)
      }
    } catch (error) {
      //console.error('Error fetching categories:', error);
    }
  }

  const [selectedGroupKey, setSelectedGroupKey] = useState(null)
  const [groupitem, setGroupitem] = useState([])

  const getgroupsitemsub = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-groups/`)
      if (response.data) {
        const treeData = transformGroupsToTree(response.data.results)
        //console.log('Tree Data:', treeData); // Log the tree data
        setGroupitem(treeData)
      }
    } catch (error) {
      //console.error('Error fetching groups:', error);
    }
  }

  const [categoriesItem, setCategoriesItem] = useState("")
  const [groupItem, setGroupItem] = useState("")

  const onloadcompany = async id => {
    try {
      const response = await axios.get(`/api/v1/contacts/${id}/`)
      if (response.data) {
        const data = response.data

        // Update form fields with fetched data
        setValue("firstname", data.first_name)
        setValue("middlename", data.middle_name)
        setValue("lastname", data.last_name)
        setValue("personal_email", data.email || "-")
        setValue("Phone", data.phone_number || "-")
        setValue("jobtitle", data.job_title || "-")
        setValue("company", data.company_name || "-")
        setValue("RelatedName", data.related_person_name || "-")
        setValue("department", data.department_name || "-")
        setValue("private", data.private)
        setValue("username", data.user_id || "-")
        setValue("password", data.watch_word)

        // Update address fields
        setTimeout(() => {
          setAddress(
            [
              data.street_address || "",
              data.street_address_line_2 || "",
              data.city_name || "",
              data.state_name || "",
              data.country_name || "",
              data.pincode || "",
              data.label || "",
            ].filter(Boolean)
          )
        }, 1000)

        setStreet1(data.street_address)
        setStreet2(data.street_address_line_2)
        setPostalCode(data.pincode)

        // Fetch and set additional data if not already fetched
        if (addCountries.length === 0) {
          await getaddCountries()
        }
        if (addStates.length === 0) {
          await getstateitems(data.country)
        }
        if (addCities.length === 0) {
          await getcity(data.state)
        }
        if (data.label) {
          const label = labels.find(l => l.id === data.label);
          setSelectedLabel(label || null);
        }

        // Find country, state, and city
        const country = addCountries.find(
          country => country.id === data.country
        )
        const state = addStates.find(state => state.id === data.state)
        const city = addCities.find(city => city.id === data.city)

        setSelectedCountry(country || null)
        setSelectedCity(city || null)
        setSelectedState(state || null)
        setDescription(data.user_notes || "-")

        setCategoriesItem(data.category_name || "-")
        setGroupItem(data.groups_name || "-")
      }
    } catch (error) {
      //console.error("Error fetching contact data:", error);
    }
  }

  const handleView = id => {
    setEditId(id)
    setisEdited(false)
    onloadcompany(id)
    setVisibleViewRight(true)
    setEditorVisible(false)
  }

  const [showArchiveConfirm, setShowArchiveConfirm] = useState(false)
  const [showArchiveSuccess, setShowArchiveSuccess] = useState(false)
  const [selectedRowIds, setSelectedRowIds] = useState([])

  const handleArchive = () => {
    const selectedIds = selectedCustomers?.map(customer => customer?.id)
    setSelectedRowIds(selectedIds)
    setShowArchiveConfirm(true)
  }

  // const confirmArchive = async () => {
  //   try {
  //     await Promise.all(
  //       selectedRowIds?.map(async id => {
  //         await axios.patch(`/api/v1/contacts/${id}/archive/`, {})
  //       })
  //     )
  //     const page = Math.floor(first / rows) + 1
  //     setShowArchiveSuccess(true)
  //     setShowArchiveConfirm(false)
  //     getallactivecontacts(page, rows, type, param)
  //     setSelectedCustomers([])
  //     // triggerAlert('success', 'Success', "Contact archived successfully")
  //   } catch (error) {
  //     triggerAlert(
  //       "error",
  //       "Error",
  //       error.response?.data?.error || "Failed to archive contact"
  //     )
  //     //console.error("Error archiving contacts:", error);
  //     setShowArchiveConfirm(false)
  //   }
  // }

  const [showUnArchiveConfirm, setShowUnArchiveConfirm] = useState(false)
  const [showUnArchiveSuccess, setShowUnArchiveSuccess] = useState(false)

  const handleUnArchive = () => {
    const selectedIds = selectedCustomers?.map(customer => customer?.id)
    setSelectedRowIds(selectedIds)
    setShowUnArchiveConfirm(true)
  }

  // const confirmUnArchive = async () => {
  //   try {
  //     await Promise.all(
  //       selectedRowIds?.map(async id => {
  //         await axios.patch(`/api/v1/contacts/${id}/unarchive/`, {})
  //       })
  //     )
  //     const page = Math.floor(first / rows) + 1
  //     setShowUnArchiveSuccess(true)
  //     setShowUnArchiveConfirm(false)
  //     getallactivecontacts(page, rows, type, param)
  //     setSelectedCustomers([])
  //     // triggerAlert('success', 'Success', "Contact archived successfully")
  //   } catch (error) {
  //     // triggerAlert('error', 'Error', error.response?.data?.message || 'Failed to archive contact');
  //     console.error("Error archiving contacts:", error)
  //   }
  // }

  //pipeline section start

  const [stages, setStages] = useState([])
  const [pipelineData, setPipelineData] = useState({})
  const [stageCounts, setStageCounts] = useState({})
  const [selectedJob, setSelectedJob] = useState({})
  const [pipelineFilters, setPipelineFilters] = useState({})
  const [pipelinePage, setPipelinePage] = useState(1) // 1-based index for backend
  const [pipelineRows, setPipelineRows] = useState(5) // 10 by default
  const [filteredPipelineData, setFilteredPipelineData] = useState({})

  // Initialize filters for each stage
  const initFilters = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    jobid: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    job_title: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    candidate: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    contact: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    company: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    date_time: { value: null, matchMode: FilterMatchMode.CONTAINS },
    user_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  }
  // Fetch stages from API
  const fetchStages = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-stages/?company_id=${companyId}`)
      if (response.data && response.data.results) {
        const sortedStages = response.data.results
          .sort((a, b) => a.order - b.order)
          ?.map(stage => stage.name.toLowerCase())
        setStages(sortedStages)

        // Initialize state for each stage
        const initialPipelineData = {}
        const initialStageCounts = {}
        const initialSelectedJobs = {}
        const initialFilters = {}
        sortedStages.forEach(stage => {
          initialPipelineData[stage] = []
          initialStageCounts[stage] = 0
          initialSelectedJobs[stage] = []
          initialFilters[stage] = initFilters
        })
        setPipelineData(initialPipelineData)
        setStageCounts(initialStageCounts)
        setSelectedJob(initialSelectedJobs)
        setPipelineFilters(initialFilters)
      } else {
        //console.warn('No stages found in API response.');
        setStages([])
      }
    } catch (error) {
      //console.error('Error fetching stages:', error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to fetch stages. Please try again.",
        life: 3000,
      })
    }
  }

  // Fetch pipeline data
  const fetchPipeline = async (contactId, page = 1, size = 10) => {
    if (!contactId) {
      //console.error('No contact ID provided.');
      return
    }

    try {
      const response = await axios.get(
        `/api/v1/candidate-contact/?contact_id=${contactId}&page=${page}&size=${size}`
      )
      if (response.data && response.data.results) {
        // Initialize pipeline data and counts
        const newPipelineData = {}
        const newStageCounts = {}
        stages.forEach(stage => {
          newPipelineData[stage] = []
          newStageCounts[stage] = 0
        })

        // Transform and group data by stage
        let assignedStage = null

        response.data.results.forEach(item => {
          const stageKey = item.stage_name?.toLowerCase() || "received"
          if (stages.includes(stageKey)) {
            if (!assignedStage) assignedStage = stageKey // Assume all data belongs to this stage
            newPipelineData[stageKey].push({
              status: item.status || "N/A",
              jobid: item.job?.job_number || "N/A",
              job_title: item.job?.job_title || "N/A",
              candidate: item.candidate_name || "N/A",
              contact: item.contact_name || "N/A",
              company: item.current_company || "N/A",
              date_time: item.created_at
                ? new Date(item.created_at).toLocaleString("en-US", {
                  timeZone: "UTC",
                  month: "numeric",
                  day: "numeric",
                  year: "numeric",
                  hour: "numeric",
                  minute: "numeric",
                  hour12: true,
                })
                : "N/A",
              user_id: item.created_by_name || "N/A",
            })
          }
        })

        // Assign full total count to the stage with data
        if (assignedStage) {
          newStageCounts[assignedStage] = response.data.count
        }

        setPipelineData(newPipelineData)
        setStageCounts(newStageCounts)
      } else {
        //console.warn('No results found in API response.');
        const emptyPipelineData = {}
        const emptyStageCounts = {}
        stages.forEach(stage => {
          emptyPipelineData[stage] = []
          emptyStageCounts[stage] = 0
        })
        setPipelineData(emptyPipelineData)
        setStageCounts(emptyStageCounts)
      }
    } catch (error) {
      //console.error('Error fetching pipeline data:', error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to fetch pipeline data. Please try again.",
        life: 3000,
      })
      const emptyPipelineData = {}
      const emptyStageCounts = {}
      stages.forEach(stage => {
        emptyPipelineData[stage] = []
        emptyStageCounts[stage] = 0
      })
      setPipelineData(emptyPipelineData)
      setStageCounts(emptyStageCounts)
    }
  }

  const handleFilterChange = (stage, filters) => {
    setPipelineFilters(prev => ({
      ...prev,
      [stage]: filters,
    }))
  }

  // Fetch stages when component mounts
  // useEffect(() => {
  //   fetchStages()
  // }, [])

  useEffect(() => {
    const newFiltered = {}
    stages.forEach(stage => {
      let filtered = [...(pipelineData[stage] || [])]
      const stageFilters = pipelineFilters[stage] || {}

      Object.entries(stageFilters).forEach(([field, filterMeta]) => {
        const { value, matchMode } = filterMeta
        if (value) {
          const filterValue = value.toString().toLowerCase()
          filtered = filtered?.filter(item => {
            const itemValue = item[field]?.toString().toLowerCase() || ""
            switch (matchMode) {
              case FilterMatchMode.STARTS_WITH:
                return itemValue.startsWith(filterValue)
              case FilterMatchMode.CONTAINS:
                return itemValue.includes(filterValue)
              default:
                return true
            }
          })
        }
      })

      newFiltered[stage] = filtered
    })

    setFilteredPipelineData(newFiltered)
  }, [pipelineData, pipelineFilters, stages])

  // Fetch pipeline data when contact ID or stages change
  useEffect(() => {
    if (
      visibleViewRight &&
      selectedCustomers.length > 0 &&
      selectedCustomers[0]?.id &&
      stages.length > 0
    ) {
      fetchPipeline(selectedCustomers[0].id, pipelinePage, pipelineRows)
    }
  }, [visibleViewRight, selectedCustomers, stages, pipelinePage, pipelineRows])

  const handleSelection = (stage, value) => {
    setSelectedJob(prev => ({
      ...prev,
      [stage]: value,
    }))
  }

  // view form pipeline ends

  //view documents start
  const [editingRow, setEditingRow] = useState(null)
  const [editedValue, setEditedValue] = useState({})
  const [documents, setDocuments] = useState([])

  const fetchDocuments = async id => {
    try {
      const response = await axios.get(`/api/v1/documents/?contact_id=${id}`)
      if (response.data && response.data.results) {
        const transformedData = response.data.results?.map(doc => ({
          key: doc.document_id.toString(),
          data: {
            document_id: doc.document_id,
            document_type: doc.document_type_name,
            document_subject: doc.document_subject,
            attachments: doc.attachments,
            created_at: moment(doc.created_at).format("YYYY-MM-DD hh:mm A"), // ✅ Proper format
          },
        }))
        setDocuments(transformedData)
        //console.log("documentsssss", documents)
      }
    } catch (error) {
      //console.error('Error fetching documents:', error);
      const errorMessage =
        error.response?.data?.error || "Failed to fetch documents."
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: errorMessage,
      })
    }
  }

  useEffect(() => {
    if (visibleViewRight && selectedCustomers.length > 0) {
      fetchDocuments(selectedCustomers[0].id)
    }
  }, [visibleViewRight, selectedCustomers])

  // Start editing a row
  const handleEditDoc = rowKey => {
    setEditingRow(rowKey)
    const doc = documents.find(doc => doc.key === rowKey)
    setEditedValue(doc ? { ...doc.data } : {})
  }

  // Save changes
  const handleSavedocument = async () => {
    try {
      const doc = documents.find(doc => doc.key === editingRow)
      if (doc) {
        const response = await axios.put(
          `/api/v1/documents/${doc.data.document_id}/`,
          {
            document_type: editedValue.document_type,
            document_subject: editedValue.document_subject,
            contact_id: selectedCustomers[0].id, // Ensure contact_id is included
          }
        )
        const updatedDocument = response.data
        setDocuments(prevDocuments =>
          prevDocuments?.map(doc =>
            doc?.key === editingRow
              ? {
                ...doc,
                data: {
                  ...doc.data,
                  docType: updatedDocument.document_type || "Unknown",
                  docSubject:
                    updatedDocument.document_subject || "No Subject",
                  createdat: updatedDocument.created_at
                    ? moment(updatedDocument.created_at).format(
                      "YYYY-MM-DD hh:mm A"
                    )
                    : doc.data.createdat,
                  document_id: updatedDocument.document_id,
                  attachments: updatedDocument.attachments || [],
                },
              }
              : doc
          )
        )
        if (response.data) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Document updated successfully",
          })
          await fetchDocuments(selectedCustomers[0].id)
        }
      }
      setEditingRow(null)
      setEditedValue({})
    } catch (error) {
      //console.error('Error saving document:', error);
      const errorMessage =
        error.response?.data?.error || "Failed to update document."
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: errorMessage,
      })
      // Optionally, show a toast notification to the user
    }
  }

  // Delete a row
  const handleDelete = async rowKey => {
    try {
      const doc = documents.find(doc => doc.key === rowKey)
      if (doc) {
        await axios.delete(`/api/v1/documents/${doc.data.document_id}/`)
        // Refresh documents after deletion
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Document deleted successfully",
        })
        await fetchDocuments(selectedCustomers[0].id)
      }
    } catch (error) {
      //console.error('Error deleting document:', error);
      const errorMessage =
        error.response?.data?.error || "Failed to delete document."
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: errorMessage,
      })
      // Optionally, show a toast notification to the user
    }
  }

  // Editable input field
  const editableTemplate = (rowData, field) => {
    if (field === "document_type") {
      return editingRow === rowData.key ? (
        <Dropdown
          value={editedValue.document_type}
          options={allDocumentTypes.map(dt => ({
            label: dt.value,
            value: dt.value, // or dt.id if your API expects id
          }))}
          onChange={e =>
            setEditedValue({ ...editedValue, document_type: e.value })
          }
          placeholder="Select Document Type"
          className="w-full"
          filter
          optionLabel="label"
          optionValue="value"
        />
      ) : (
        <span onClick={() => handleEditDoc(rowData.key)}>
          {rowData.data.document_type}
        </span>
      );
    }
    return editingRow === rowData.key ? (
      <InputText
        value={editedValue[field] || ""}
        onChange={e =>
          setEditedValue({ ...editedValue, [field]: e.target.value })
        }
        autoFocus
      />
    ) : (
      <span onClick={() => handleEditDoc(rowData.key)}>
        {rowData.data[field]}
      </span>
    )
  }

  // Action buttons
  const actionTemplate = rowData => {
    return (
      <div className="flex gap-2">
        {editingRow === rowData.key ? (
          <Button
            icon="pi pi-check"
            rounded
            outlined
            className="document-btn"
            onClick={handleSavedocument}
          />
        ) : (
          <Button
            icon="pi pi-pencil"
            rounded
            outlined
            className="document-btn"
            onClick={() => handleEditDoc(rowData.key)}
          />
        )}
        <Button
          icon="pi pi-trash"
          rounded
          outlined
          className="document-btn"
          onClick={() => handleDelete(rowData.key)}
        />
      </div>
    )
  }

  const attachmentBodyTemplate = rowData => {
    const attachments = rowData.data.attachments || []
    const maxFileNameLength = 20

    if (attachments.length === 0) {
      return <span>No attachments</span>
    }

    const truncateFileName = fileName => {
      if (fileName.length <= maxFileNameLength) return fileName
      const extension = fileName.split(".").pop()
      const nameWithoutExtension = fileName.slice(0, -(extension.length + 1))
      return `${nameWithoutExtension.slice(
        0,
        maxFileNameLength - extension.length - 3
      )}...${extension}`
    }

    return (
      <div className="flex flex-column gap-2">
        {attachments?.map(attachment => (
          <a
            key={attachment?.attachment_id}
            href={attachment?.file_path}
            download={attachment?.file_name}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary hover:underline"
            title={`Download ${attachment?.file_name}`}
          >
            {truncateFileName(attachment?.file_name)}
          </a>
        ))}
      </div>
    )
  }

  // view form activities starts

  const [activitiesFilters, setActivitiesFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    event_type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    event_sub_type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    event_priority: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    subject: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    event_time: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    user_ids: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  })

  const [activityTotalRecords, setActivityTotalRecords] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [activities, setActivities] = useState([])
  const [selectedActivities, setSelectedActivities] = useState([])
  const [loading1, setLoading1] = useState(false);

  const CustomLoader = () => (
    <OrgTableShimmer columns={6} rows={6} titleWidth="220px" />
  );

const paginationComponentOptions = {
    selectAllRowsItem: true,
    selectAllRowsItemText: "All",
  }

  const [filteredActivities, setFilteredActivities] = useState([])
  const fetchActivities = async (id, page = 1, size = rowsPerPage) => {
    try {
      const response = await axios.get(
        `/api/v1/activity-log/?contact_id=${id}&page=${page}&size=${size}`
      )
      setActivities(response.data?.results)
      setActivityTotalRecords(response.data?.count) // Adjust if your API uses a different field for total count
      setCurrentPage(page)
    } catch {
      // handle error
      console.error("Error fetching activities:", error)
      setActivities([])
      setActivityTotalRecords(0)
    }
  }

  useEffect(() => {
    let filtered = [...activities]

    Object.entries(activitiesFilters).forEach(([field, filterMeta]) => {
      const { value, matchMode } = filterMeta
      if (value) {
        filtered = filtered?.filter(item => {
          const fieldValue = item[field]?.toString().toLowerCase() || ""
          const filterValue = value.toLowerCase()
          return fieldValue.includes(filterValue)
        })
      }
    })

    setFilteredActivities(filtered)
  }, [activities, activitiesFilters])

  useEffect(() => {
    if (visibleViewRight && selectedCustomers.length > 0) {
      fetchActivities(selectedCustomers[0].id, currentPage, rowsPerPage)
    } else {
      // Reset contacts if no company is selected
      setActivities([])
      setActivityTotalRecords(0)
    }
  }, [visibleViewRight, selectedCustomers, rowsPerPage])

  //   const onPageChangeActivity = (event) => {
  //   setPage1(event.page);
  //   setRows1(event.rows);
  // };

  // view form activities ends

  // view form history starts

  const [historyFilters, setHistoryFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    sub_type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    priority: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    subject: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    datetime: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    user_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  })

  const [history, setHistory] = useState([])
  const [totalRecordss, setTotalRecords] = useState(0)
  const [currentPage1, setCurrentPage1] = useState(1)
  const [rowsPerPage1, setRowsPerPage1] = useState(5)
  const [selectedHistory, setSelectedHistory] = useState([])
  const [filteredHistory, setFilteredHistory] = useState([])

  const fetchhistory = async (id, page = 1, size = rowsPerPage1) => {
    try {
      const response = await axios.get(
        `/api/v1/history/?contact_id=${id}&page=${page}&size=${size}`
      )
      setHistory(response.data?.results)
      setTotalRecords(response.data?.count) // Assuming your API returns count
      setCurrentPage1(page)
    } catch (error) {
      console.error("Error fetching history:", error)
      setHistory([])
      setTotalRecords(0)
    }
  }

  useEffect(() => {
    let filtered = [...history]

    Object.entries(historyFilters).forEach(([field, filterMeta]) => {
      const { value, matchMode } = filterMeta
      if (value) {
        filtered = filtered?.filter(item => {
          const fieldValue = item[field]?.toString().toLowerCase() || ""
          const filterValue = value.toLowerCase()
          return fieldValue.includes(filterValue)
        })
      }
    })

    setFilteredHistory(filtered)
  }, [history, historyFilters])

  useEffect(() => {
    if (visibleViewRight && selectedCustomers.length > 0) {
      fetchhistory(selectedCustomers[0].id, currentPage1, rowsPerPage1)
    } else {
      // Reset contacts if no company is selected
      setHistory([])
      setTotalRecords(0)
    }
  }, [visibleViewRight, selectedCustomers, rowsPerPage1])

  // const onPageChangehistory = (event) => {
  //   setPage(event.page);
  //   setRows(event.rows);
  // };

  // view form history ends

  // view form notes starts
  const [isEditorVisible, setEditorVisible] = useState(false) // Manage editor visibility
  const [editorContent, setEditorContent] = useState("") // Manage editor content
  const [editIndex, setEditIndex] = useState(null)
  const [candidateNotes, setCandidateNotes] = useState([]) // Store notes in an array

  const fetchNotes = async contactId => {
    try {
      const response = await axios.get(`/api/v1/notes/?contact_id=${contactId}`)
      if (response.data && response.data.results) {
        setCandidateNotes(response.data.results)
      }
    } catch (error) {
      //console.error('Error fetching notes:', error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message || "Failed to fetch notes",
      })
    }
  }

  const saveNote = async noteData => {
    try {
      const response = await axios.post("/api/v1/notes/", noteData)
      if (response.data) {
        // Optionally, fetch the updated list of notes
        fetchNotes(editId)

        // setVisibleViewRight(false);
        // triggerAlert('success', 'Success', 'Notes created successfully')
      }
    } catch (error) {
      //console.error('Error saving note:', error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message || "Failed to create notes",
      })
      setVisibleViewRight(false)
    }
  }
  const updateNote = async (noteId, noteData) => {
    try {
      const response = await axios.put(`/api/v1/notes/${noteId}/`, noteData)
      if (response.data) {
        // setVisibleViewRight(false);
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Notes updated successfully",
        })
        fetchNotes(editId)

        // triggerAlert('success', 'Success', 'Notes updated successfully')
      }
    } catch (error) {
      //console.error('Error updating note:', error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message || "Failed to update notes",
      })
      setVisibleViewRight(false)
    }
  }

  const handleAddNotes = () => {
    setEditorVisible(true) // Show the editor
    setEditorContent("") // Clear any previous content
    setEditIndex(null) // Reset editIndex when adding a new note
  }

  const handleSaveNotes = () => {
    if (!editorContent || editorContent.trim() === '') {
      return;
    }
    if (editorContent.trim()) {
      const currentDateTime = new Date().toISOString()
      const noteData = {
        notes: editorContent,
        created_at: currentDateTime,
        contact_id: editId,
      }

      if (editIndex !== null) {
        // Update existing note
        const noteToUpdate = candidateNotes[editIndex]
        updateNote(noteToUpdate.note_id, noteData)
      } else {
        // Save new note
        saveNote(noteData)
      }

      setEditorContent("")
      // setEditorVisible(false);
      // setEditIndex(null);
    }
  }

  useEffect(() => {
    if (visibleViewRight && editId) {
      fetchNotes(editId)
    }
  }, [visibleViewRight, editId])

  const handleCancelNotes = () => {
    setEditorContent("")
    setEditorVisible(false)
    setEditIndex(null)
  }

  const handleEditNote = index => {
    const noteToEdit = candidateNotes[index]
    setEditorVisible(true)
    setEditorContent(noteToEdit.notes || noteToEdit.content) // Load the note content into the editor
    setEditIndex(index)
  }

  const handleDeleteNote = async index => {
    const noteToDelete = candidateNotes[index]
    try {
      await axios.delete(`/api/v1/notes/${noteToDelete.note_id}/`)
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Notes deleted successfully",
      })
      const updatedNotes = candidateNotes?.filter((_, i) => i !== index)
      setCandidateNotes(updatedNotes)
      // setVisibleViewRight(false);
    } catch (error) {
      //console.error('Error deleting note:', error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message || "Failed to delete notes",
      })
      setVisibleViewRight(false)
    }
  }

  // view form notes ends

  // view ends

  //////new email//

  const [popchecked, setPopchecked] = useState(false)
  const [popchecked2, setPopchecked2] = useState(false)

  const [filteredJobs, setFilteredJobs] = useState([])

  const handlePopupCheckbox = e => {
    setPopchecked(e.checked)
  }
  const [totalRecordsCandidates, setTotalRecordsCandidates] = useState(0)
  const [lazyParamsCandidates, setLazyParamsCandidates] = useState({
    first: 0,
    rows: 10,
    page: 1,
  })

  // const getAllActive = async (page, size) => {
  //   try {
  //     const response = await axios.get(
  //       `/api/v1/candidates/?page=${page}&size=${size}&company_id=${companyId}`
  //     )
  //     if (response.data) {
  //       setFilteredJobs(response.data.results || [])
  //     }
  //     const transformedData = response.data.results?.map(cond => ({
  //       name: cond?.first_name,
  //       id: cond?.candidate_id,
  //     }))
  //     settypeInterviewcondi(transformedData)
  //     const transformedDataemail = response.data.results?.map(cond => ({
  //       email: cond?.email,
  //       id: cond?.candidate_id,
  //     }))
  //     setTotalRecordsCandidates(response.data.count || 0)
  //   } catch (error) {
  //     console.error("Error fetching candidates:", error)
  //   }
  // }

  const onPageChangeCandidates = event => {
    setLazyParamsCandidates({
      ...lazyParamsCandidates,
      first: event.first,
      rows: event.rows,
      page: event.page + 1,
    })
    getAllActive(event.page + 1, event.rows)
  }

  useEffect(() => {
    // getAllActive(lazyParamsCandidates.page, lazyParamsCandidates.rows)
  }, [lazyParamsCandidates.page, lazyParamsCandidates.rows])

  const [selectedJobs, setSelectedJobs] = useState([])

  const handleSelectionChange = e => {
    const selectedEmails = e.value?.map(job => job.email)
    setSelectedJobs(e.value)
    settoemailinp(selectedEmails)
  }

  const fullNameTemplate = rowData => {
    return `${rowData?.first_name ? "" + rowData?.first_name : ""}${rowData?.middle_name ? " " + rowData?.middle_name : ""
      } ${rowData?.last_name ? "" + rowData?.last_name : ""}`
  }

  /////

  // interview
  const [interviewpop, SetInterviewpop] = useState(false)

  const [subtype, setSubtype] = useState(null)
  const [subtypeget, setsubtypeget] = useState(null)
  const [startdate, setStartdate] = useState(null)
  const [starttime, setStarttime] = useState(null)
  const [enddate, setEnddate] = useState(null)
  const [endtime, setEndtime] = useState(null)
  const [popTextares, setPopTextares] = useState("")
  const [priority, setPriority] = useState(null)
  const [prioritycontact, setprioritycontact] = useState(null)
  const [contactvalu, setcontactvalu] = useState([])
  const [condidatevalu, setcondidatevalu] = useState([])
  const {
    register: register1,
    formState: { errors: errors1 },
    handleSubmit: handleSubmit1,
    getValues: getValues1,
    setValue: setValue1,
    trigger: trigger1,
    reset: reset1,
  } = useForm({ mode: "onBlur" })
  const [selectedScheduleOption, setSelectedScheduleOption] = useState(null)
  const [intertype, setintertype] = useState("Interview")
  const [typeInterviewcondi, settypeInterviewcondi] = useState([])
  const [subjectval, setsubjectval] = useState(null)

  useEffect(() => {
    const now = new Date()

    const startDate = new Date() // today
    const endDate = new Date() // today

    const startTime = new Date() // current time
    const endTime = new Date(now.getTime() + 30 * 60000) // 30 minutes later

    setStartdate(startDate)
    setEnddate(endDate)
    setStarttime(startTime)
    setEndtime(endTime)
  }, [])

  const resetDefaultDateTime = () => {
    const now = new Date()
    const startDate = new Date() // today
    const endDate = new Date() // today
    const startTime = new Date() // now
    const endTime = new Date(now.getTime() + 30 * 60000) // 30 minutes later

    setStartdate(startDate)
    setEnddate(endDate)
    setStarttime(startTime)
    setEndtime(endTime)

    setReminder("10 minutes")

    // setstartdateinterview('');
    // setsenddateinterview('');
    // setstarttimeinterview('');
    // setsendtimeinterview('');
  }

  const [typeInterview, settypeInterview] = useState([])

  const priorityType = [
    { name: "Low", value: "Low" },
    { name: "Medium", value: "Medium" },
    { name: "High", value: "High" },
  ]

  const getScheduleSubType = async scheduleId => {
    try {
      const response = await axios.get(
        `/api/v1/get-all-schedule-sub-type/?schedule_id=${scheduleId}`
      )
      // Ensure the response data is correctly structured
      const trans = response.data.results?.map(item => ({
        id: item?.id,
        label: item?.schedule_subtype,
        description: item?.description,
        type: item?.type,
      }))
      settypeInterview(trans)
    } catch (error) {
      //console.error("Error fetching schedule types:", error);
    }
  }
  const [reminder, setReminder] = useState("10 minutes")
  const reminderOptions = [
    { name: "0 mins", value: "0 minutes" },
    { name: "5 mins", value: "5 minutes" },
    { name: "10 mins", value: "10 minutes" },
    { name: "15 mins", value: "15 minutes" },
    { name: "30 mins", value: "30 minutes" },
  ]
  const [repeat, setRepeat] = useState(null)
  const repeatOptions = [
    { name: "Do not repeat", value: "none" },
    { name: "Daily", value: "Daily" },
    { name: "Weekly", value: "Weekly" },
    { name: "Mon-Fri", value: "Mon-Fri" },
  ]

  const [followup, setFollowup] = useState(null)

  // Dropdown options
  const followupOptions = [
    { name: "None", value: "none" },
    { name: "1 Day", value: "1 Day" },
    { name: "2 Days", value: "2 Day" },
    { name: "3 Days", value: "3 Day" },
  ]
  const handlePopupCheckbox2 = e => {
    setPopchecked2(e.checked)
  }
  const [userid, setUserid] = useState([])
  const customChip = item => {
    return (
      <div>
        <span>{item} - (active)</span>
        <i className="pi pi-user-plus"></i>
      </div>
    )
  }

  const [warningDialogVisible, setWarningDialogVisible] = useState(false)
  const [callingtask, setcallingtask] = useState(false)
  const handleScheduleChange = (value, label, isRightClick = false) => {
    setSelectedScheduleOption(value)
    setintertype(value.label)
    setStartdate(null)
    setStarttime(null)
    setEnddate(null)
    setEndtime(null)

    const selected = value

    // console.log(selected)

    if (value && value.action) {
      value.action() // Execute the custom action
    }
    if (
      selected?.label?.toLowerCase() === "call" ||
      selected?.label?.toLowerCase() === "meeting"
    ) {
      setcallingtask(true)
    } else {
      setcallingtask(false)
    }

    if (value.id) {
      getScheduleSubType(value.id)
    }

    // Determine the selected contact based on the selection method
    const selectedContactData = isRightClick
      ? selectedContact
      : selectedCustomers.length > 0
        ? selectedCustomers[0]
        : null
    if (selectedContactData) {
      setJobTitle(selectedContactData.job_title || "")
    }

    // Check if the selected schedule type is one of the options that should open the dialog
    const shouldOpenDialog = scheduleOptions.some(
      option => option.label === value?.label
    )

    if (isRightClick && selectedContactData) {
      SetInterviewpop(true)
    } else if (!isRightClick && selectedCustomers.length === 0) {
      setWarningDialogVisible(true)
    } else if (!isRightClick && shouldOpenDialog) {
      SetInterviewpop(true)
    }
  }

  const handleCancelInterview = () => {
    SetInterviewpop(false)
    setSubtype(null)
    setsubtypeget(null)
    setStartdate(new Date())
    setStarttime(new Date())
    setEnddate(null)
    setEndtime(null)
    setPopTextares("")
    setPriority(null)
    setprioritycontact(null)
    // setcontactvalu([]);
    setcondidatevalu([])
    setsubjectval(null)
    setPopchecked(false)
    setPopchecked2(false)
    setReminder(null)
    setRepeat(null)
    setFollowup(null)
    setNewErrors({})
    setSelectedContact(null)
  }
  const [newErrors, setNewErrors] = useState({})

  const onSubmitinterview = async data => {
    let isValid = true
    const errors = {}

    // Removed mandatory validation for Jobs, Contact, and Linked Candidates

    // if (!subtype) {
    //   errors.subtype = 'Sub-Type is required.';
    //   isValid = false;
    // }

    // if (!popTextares) {
    //   errors.popTextares = 'Text is required.';
    //   isValid = false;
    // }

    // if (!startdate) {
    //   errors.startdate = 'Start date is required.';
    //   isValid = false;
    // }

    // if (!starttime) {
    //   errors.starttime = 'Start time is required.';
    //   isValid = false;
    // }

    // if (!enddate) {
    //   errors.enddate = 'End date is required.';
    //   isValid = false;
    // }

    // if (!endtime) {
    //   errors.endtime = 'End time is required.';
    //   isValid = false;
    // }

    // if (!priority) {
    //   errors.priority = 'Priority is required.';
    //   isValid = false;
    // }

    // if (!followup) {
    //   errors.followup = 'Follow-up is required.';
    //   isValid = false;
    // }

    // if (!repeat) {
    //   errors.repeat = 'Repeat is required.';
    //   isValid = false;
    // }

    // if (!reminder) {
    //   errors.reminder = 'Reminder is required.';
    //   isValid = false;
    // }

    if (startdate && enddate && starttime && endtime) {
      const startDateStr = moment(startdate).format("YYYY-MM-DD")
      const endDateStr = moment(enddate).format("YYYY-MM-DD")

      if (
        startDateStr === endDateStr &&
        moment(endtime).isBefore(moment(starttime))
      ) {
        errors.endtime =
          "End time cannot be earlier than start time on the same day."
        isValid = false
      }
    }

    if (startdate && enddate && moment(enddate).isBefore(moment(startdate))) {
      errors.enddate = "End date cannot be earlier than start date."
      isValid = false
    }

    if (!isValid) {
      setNewErrors(errors)

      return
    }

    if (!isValid) {
      return
    }
    let req = {}

    if (intertype) {
      req.event_type = intertype
    }

    if (subtype) {
      req.event_sub_type = subtype.label
    }

    if (enddate) {
      req.end_date = moment(enddate).format("YYYY-MM-DD")
    }
    if (startdate) {
      req.start_date = moment(startdate).format("YYYY-MM-DD")
    }
    if (starttime) {
      req.start_time = moment(starttime).format("HH:mm:ss")
    }
    if (endtime) {
      req.end_time = moment(endtime).format("HH:mm:ss")
    }

    if (subtypeget && subtypeget.length > 0) {
      req.job_id = subtypeget
    }
    if (condidatevalu && condidatevalu.length > 0) {
      // If condidatevalu is an array of IDs
      req.candidate_id = condidatevalu
    }

    if (subjectval) {
      req.subject = subjectval
    }

    if (popTextares) {
      req.description = popTextares
    }

    if (priority) {
      req.event_priority = priority
    }
    if (followup) {
      req.auto_followup = followup
    }
    if (repeat) {
      req.repeat = repeat
    }

    req.reminder = reminder

    req.completed = popchecked
    req.private = popchecked2

    if (contactvalu && contactvalu.length > 0) {
      req.contact_id = contactvalu?.map(c =>
        typeof c === "object" && c !== null ? c?.id : c
      )
    }

    // req.status = 1;
    // req.user_ids= uniqueUserId;
    req.event_time = moment().format("YYYY-MM-DDTHH:mm:ssZ")

    try {
      //console.log('Request payload:', req);
      const response = await axios.post(`/api/v1/events/`, req)
      //console.log('Response:', response.data);
      triggerAlert("success", "Success", "Event created successfully!")
      handleCancelInterview()
    } catch (error) {
      //console.error('Error submitting form:', error);
      if (error.response) {
        //console.error('Error response:', error.response.data);
        const errorMessage = error.response.data.error?.candidate_id
          ? `Invalid candidate ID: ${error.response.data.error.candidate_id.join(
            ", "
          )}`
          : error.response?.data?.error || "Failed to create event"
        triggerAlert("error", "Error", errorMessage)
        handleCancelInterview()
      } else {
        triggerAlert(
          "error",
          "Error",
          "An unexpected error occurred. Please try again."
        )
        handleCancelInterview()
      }
    }
  }

  const [typeInterviewval, settypeInterviewval] = useState([])
  const [typeInterviewcontact, settypeInterviewcontact] = useState([])
  const [allcontacts, setAllContacts] = useState([])

  const contactlist = e => {
    // Set the value based on checkbox
    setcontactvalu(e.value)
  }
  const getjobs = async () => {
    try {
      const response = await axios.get(`/api/v1/jobs/?status=Approved / Open&company_id=${companyId}`, {})

      // Transform data if needed to match the Dropdown format
      const transformedData = response.data.results?.map(city => ({
        name: city?.job_title,
        id: city?.job_id,
      }))
      settypeInterviewval(transformedData)
    } catch (error) { }
  }

  const [totalRecordsContacts, setTotalRecordsContacts] = useState(0)
  const [lazyParamsContacts, setLazyParamsContacts] = useState({
    first: 0,
    rows: 10,
    page: 1,
  })
  const mapUserToEmployeeRow = user => {
    const { password, watch_word, user_permissions, ...safeUser } = user || {}
    const fullName = [
      safeUser.first_name,
      safeUser.middle_name,
      safeUser.last_name,
    ].filter(Boolean).join(" ")

    return {
      ...safeUser,
      id: safeUser.id,
      contact_id: safeUser.id,
      user_id: safeUser.id,
      name: fullName || safeUser.email || "--",
      phone_number: safeUser.phone_number || safeUser.mobile_phone || "--",
      company_name: safeUser.company_name || "--",
      department_name: safeUser.department_name || "--",
      designation_name: safeUser.designation_name || "--",
      primary_manager_name: safeUser.primary_manager_name || "--",
      employee_code: safeUser.employee_code || "--",
      role_name: safeUser.role_name || "--",
      status: safeUser.status || (safeUser.is_active ? "Active" : "Inactive"),
    }
  }

  const getallactivecontacts = async (page, size,search = "") => {
    try {
      setLoading1(true);
      const params = {
        page,
        size,
        company_id: companyId,
      }

      if (search?.trim()) {
        params.search = search.trim()
      }

      const response = await axios.get(`/api/v1/users/`, { params })
      const employees = Array.isArray(response.data?.results)
        ? response.data.results.map(mapUserToEmployeeRow)
        : []
      const transformedData = employees?.map(employee => ({
        name: employee?.name,
        id: employee?.id,
      }))
      settypeInterviewcontact(transformedData)
      setAllContacts(employees)
      setTotalRecordsContacts(response.data.count || 0)
      setSelectedCustomers([])
      setselectedEmployees(0)
    } catch (error) {
      console.error("Error fetching employees:", error)
      setAllContacts([])
      setTotalRecordsContacts(0)
    }
    finally {
    setLoading1(false); 
  }
  }
const handlePageChange = (page) => {
  setCurrentPage(page);
  getallactivecontacts(page, rowsPerPage,searchQuery);
};
const tableKey = `${companyId}-${rowsPerPage}`;

const handlePerRowsChange = (newPerPage, page) => {
  setRowsPerPage(newPerPage);
  setCurrentPage(1);    
  getallactivecontacts(1, newPerPage,searchQuery);
};

  const [interviewdroptype, setinterviewdroptype] = useState([])

  const getallinterviewdrop = async () => {
    try {
      const response = await axios.get(`/api/v1/event-lookup/`, {})
      const data = response.data
      const types = data.types?.map(type => ({
        label: type,
      }))
      if (response.data === 500) {
      }

      setinterviewdroptype(types)
    } catch (error) {
      console.error("Error fetching interview drop types:", error)
    }
  }

  // useEffect(() => {
  //   // getjobs()

  //   // getallinterviewdrop()
  // }, [])
  // useEffect(() => {
  //   getallactivecontacts1(lazyParamsContacts.page, lazyParamsContacts.rows)
  // }, [lazyParamsContacts.page, lazyParamsContacts.rows])

  // clear search start

  const handleClearSearchContacts = () => {
    setFilters({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      first_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      last_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      company_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      job_title: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      email: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      phone_number: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      AssociatedContacts: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      department_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      full_address: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      notes: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      category_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      groups_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      user_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      created_by_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      last_activity_type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      last_activity_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      created_at: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      updated_at: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    });
  };

  // clear search start

  // Export Csv start

  const [importCsvIcons, setImportCsvIcons] = useState(false)
  const dtContact = useRef(null)

  // ...existing code...

  const exportCSVBtn = () => {
    const dataToExport =
      selectedCustomers.length > 0 ? selectedCustomers : customers

    // Function to escape CSV values
    const escapeCsvValue = value => {
      if (value === null || value === undefined) {
        return " "
      }
      const stringValue = String(value)
      if (
        stringValue.includes(",") ||
        stringValue.includes("\n") ||
        stringValue.includes('"')
      ) {
        return `"${stringValue.replace(/"/g, '""')}"`
      }
      return stringValue
    }

    let fields = []
    let csvHeader = ""
    let csvRows = []

    if (type === "task-list") {
      fields = [
        "event_type",
        "event_sub_type",
        "event_time",
        "start_date_time",
        "end_date_time",
        "event_priority",
        "subject",
        "status",
        "created_by_name",
      ]
      csvHeader = fields?.map(field => escapeCsvValue(field)).join(",")
      csvRows = dataToExport?.map(item =>
        fields
          ?.map(field => {
            let value = item[field] || " "
            // Format all date/time fields
            if (
              field === "event_time" ||
              field === "start_date_time" ||
              field === "end_date_time"
            ) {
              value = item[field]
                ? moment(item[field]).format("YYYY-MM-DD hh:mm A")
                : " "
            }
            return escapeCsvValue(value)
          })
          .join(",")
      )
    } else if (type === "activity_log") {
      fields = [
        "event_type",
        "event_sub_type",
        "event_priority",
        "subject",
        "status",
        "start_date",
        "end_date",
        "created_by_name",
      ]
      csvHeader = fields?.map(field => escapeCsvValue(field)).join(",")
      csvRows = dataToExport?.map(item =>
        fields
          ?.map(field => {
            let value = item[field] || " "
            // Format all date fields
            if (field === "start_date" || field === "end_date") {
              value = item[field]
                ? moment(item[field]).format("YYYY-MM-DD hh:mm A")
                : " "
            }
            return escapeCsvValue(value)
          })
          .join(",")
      )
    } else {
      fields = [
        "first_name",
        "last_name",
        "company_name",
        "job_title",
        "email",
        "phone_number",
        "associated_contacts",
        "department_name",
        "full_address",
        "status",
        "category_name",
        "groups_name",
        "created_by_name",
        "user_id",
        "last_activity_type",
        "last_activity_date",
        "created_at",
        "updated_at",
      ]
      csvHeader = fields?.map(field => escapeCsvValue(field)).join(",")
      csvRows = dataToExport?.map(item =>
        fields
          ?.map(field => {
            let value = item[field] || " "
            // Format all date fields
            if (
              field === "last_activity_date" ||
              field === "created_at" ||
              field === "updated_at"
            ) {
              value = item[field] || " ";
            }
            return escapeCsvValue(value)
          })
          .join(",")
      )
    }

    // Combine header and rows
    const csvContent =
      "data:text/csv;charset=utf-8," + csvHeader + "\n" + csvRows.join("\n")

    // Create a download link for the CSV
    const encodedUri = encodeURI(csvContent)
    const link = document.createElement("a")
    link.setAttribute("href", encodedUri)
    link.setAttribute("download", "contacts.csv")
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  // ...existing code...

  const exportPdfBtn = fileName => {
    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default("landscape")
        const dataToExport =
          selectedCustomers.length > 0 ? selectedCustomers : customers

        let exportColumns = []
        let exportData = []

        if (type === "task-list") {
          exportColumns = [
            { header: "Event Type", dataKey: "event_type" },
            { header: "Event Sub Type", dataKey: "event_sub_type" },
            { header: "Event Time", dataKey: "event_time" },
            { header: "Start Date Time", dataKey: "start_date_time" },
            { header: "End Date Time", dataKey: "end_date_time" },
            { header: "Event Priority", dataKey: "event_priority" },
            { header: "Subject", dataKey: "subject" },
            { header: "Status", dataKey: "status" },
            { header: "Created By", dataKey: "created_by_name" },
          ]

          exportData = dataToExport?.map(row => ({
            event_type: row?.event_type || " ",
            event_sub_type: row?.event_sub_type || " ",
            event_time: row?.event_time
              ? moment.utc(row.event_time).format("DD/MM/YYYY HH:mm")
              : " ",
            start_date_time: row?.start_date_time
              ? moment.utc(row.start_date_time).format("DD/MM/YYYY HH:mm")
              : " ",
            end_date_time: row?.end_date_time
              ? moment.utc(row.end_date_time).format("DD/MM/YYYY HH:mm")
              : " ",
            event_priority: row?.event_priority || " ",
            subject: row?.subject || " ",
            status: row?.status || " ",
            created_by_name: row?.created_by_name || " ",
          }))
        } else if (type === "activity_log") {
          exportColumns = [
            { header: "Event Type", dataKey: "event_type" },
            { header: "Event Sub Type", dataKey: "event_sub_type" },
            { header: "Event Priority", dataKey: "event_priority" },
            { header: "Subject", dataKey: "subject" },
            { header: "Status", dataKey: "status" },
            { header: "Start Date", dataKey: "start_date" },
            { header: "End Date", dataKey: "end_date" },
            { header: "Created By", dataKey: "created_by_name" },
          ]

          exportData = dataToExport?.map(row => ({
            event_type: row?.event_type || " ",
            event_sub_type: row?.event_sub_type || " ",
            event_priority: row?.event_priority || " ",
            subject: row?.subject || " ",
            status: row?.status || " ",
            start_date: row?.start_date
              ? moment.utc(row.start_date).format("DD/MM/YYYY")
              : " ",
            end_date: row?.end_date
              ? moment.utc(row.end_date).format("DD/MM/YYYY")
              : " ",
            created_by_name: row?.created_by_name || " ",
          }))
        } else {
          exportColumns = [
            { header: "First Name", dataKey: "first_name" },
            { header: "Last Name", dataKey: "last_name" },
            { header: "Company", dataKey: "company_name" },
            // { header: "Job Title", dataKey: "job_title" },
            { header: "Email", dataKey: "email" },
            { header: "Mobile", dataKey: "phone_number" },
            { header: "Associated Contacts", dataKey: "associated_contacts" },
            { header: "Department", dataKey: "department_name" },
            { header: "Full Address", dataKey: "full_address" },
            { header: "Status", dataKey: "status" },
            { header: "Category", dataKey: "category_name" },
            { header: "Group", dataKey: "groups_name" },
            { header: "Created By", dataKey: "created_by_name" },
            { header: "User ID", dataKey: "user_id" },
            { header: "Last Activity Type", dataKey: "last_activity_type" },
            { header: "Last Activity Date", dataKey: "last_activity_date" },
            { header: "Created At", dataKey: "created_at" },
            { header: "Updated At", dataKey: "updated_at" },
          ]

          exportData = dataToExport?.map(row => ({
            first_name: row?.first_name || " ",
            last_name: row?.last_name || " ",
            company_name: row?.company_name || " ",
            job_title: row?.job_title || " ",
            email: row.email || " ",
            phone_number: row?.phone_number || " ",
            associated_contacts: row?.associated_contacts || " ",
            department_name: row?.department_name || " ",
            full_address: row?.full_address || " ",
            status: row?.status || " ",
            category_name: row?.category_name || " ",
            groups_name: row?.groups_name || " ",
            created_by_name: row?.created_by_name || " ",
            user_id: row?.user_id || " ",
            last_activity_type: row?.last_activity_type || " ",
            created_at: row?.created_at
              ? moment.utc(row.created_at).format("DD/MM/YYYY HH:mm")
              : " ",
            updated_at: row?.updated_at
              ? moment.utc(row.updated_at).format("DD/MM/YYYY HH:mm")
              : " ",
            last_activity_date: row?.last_activity_date
              ? moment(row.last_activity_date).format("DD/MM/YYYY HH:mm")
              : " ",
          }))
        }

        if (exportColumns.length === 0 || exportData.length === 0) {
          alert("No data available for export.")
          return
        }

        doc.autoTable({
          head: [exportColumns?.map(col => col.header)],
          body: exportData?.map(item =>
            exportColumns?.map(col => item[col.dataKey])
          ),
          startY: 20,
          styles: { fontSize: 7, cellPadding: 1, overflow: "linebreak" },
          theme: "grid",
          margin: { top: 10, left: 5, right: 5 },
          columnStyles: exportColumns.reduce((acc, _, index) => {
            acc[index] = { cellWidth: "auto" }
            return acc
          }, {}),
        })

        doc.save(`${fileName}.pdf`)
      })
    })
  }

  const exportExcelBtn = fileName => {
    import("xlsx").then(xlsx => {
      const dataToExport =
        selectedCustomers.length > 0 ? selectedCustomers : customers
      let exportData = []

      if (type === "task-list") {
        exportData = dataToExport?.map(row => ({
          "Event Type": row?.event_type || " ",
          "Event Sub Type": row?.event_time
            ? moment.utc(row.event_time).format("DD/MM/YYYY hh:mm A")
            : " ",
          "Start Date Time": row?.start_date_time
            ? moment.utc(row.start_date_time).format("DD/MM/YYYY hh:mm A")
            : " ",
          "End Date Time": row?.end_date_time
            ? moment.utc(row.end_date_time).format("DD/MM/YYYY hh:mm A")
            : " ",
          "Event Priority": row?.event_priority || " ",
          Subject: row?.subject || " ",
          Status: row?.status || " ",
          "Created By": row?.created_by_name || " ",
        }))
      } else if (type === "activity_log") {
        exportData = dataToExport?.map(row => ({
          "Event Type": row?.event_type || " ",
          "Event Sub Type": row?.event_sub_type || " ",
          "Event Priority": row?.event_priority || " ",
          Subject: row?.subject || " ",
          Status: row?.status || " ",
          "Start Date": row?.start_date
            ? moment(row.start_date).format("DD/MM/YYYY hh:mm A")
            : " ",
          "End Date": row?.end_date
            ? moment(row.end_date).format("DD/MM/YYYY hh:mm A")
            : " ",
          "Created By": row?.created_by_name || " ",
        }))
      } else {
        exportData = dataToExport?.map(row => ({
          "First Name": row?.first_name || " ",
          "Last Name": row?.last_name || " ",
          Company: row?.company_name || " ",
          "Job Title": row?.job_title || " ",
          Email: row?.email || " ",
          Mobile: row?.phone_number || " ",
          "Associated Contacts": row?.associated_contacts || " ",
          Department: row?.department_name || " ",
          "Full Address": row?.full_address || " ",
          Status: row?.status || " ",
          Category: row?.category_name || " ",
          Group: row?.groups_name || " ",
          "Created By": row?.created_by_name || " ",
          "User ID": row?.user_id || " ",
          "Last Activity Type": row?.last_activity_type || " ",
          "Last Activity Date": row?.last_activity_date
            ? moment(row.last_activity_date).format("YYYY-MM-DD hh:mm A")
            : " ",
          "Created At": row?.created_at
            ? moment(row.created_at).format("YYYY-MM-DD hh:mm A")
            : " ",
          "Updated At": row?.updated_at
            ? moment(row.updated_at).format("YYYY-MM-DD hh:mm A")
            : " ",
        }))
      }

      const worksheet = xlsx.utils.json_to_sheet(exportData)
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] }
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      })
      saveAsExcelFile(excelBuffer, fileName)
    })
  }


  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then(module => {
      if (module && module.default) {
        const EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
        const EXCEL_EXTENSION = ".xlsx"
        const data = new Blob([buffer], { type: EXCEL_TYPE })

        module.default.saveAs(
          data,
          `${fileName}_export_${new Date().getTime()}${EXCEL_EXTENSION}`
        )
      }
    })
  }

  const headerBtn = (
    <div className="flex align-items-center justify-content-end gap-1 actionitem-import">
      <Button
        className="csvbtn p-button"
        icon="pi pi-file"
        rounded
        onClick={exportCSVBtn}
        tooltip="Export to CSV"
        disabled={customers.length === 0}
      />
      <Button
        className="xlsbtn p-button"
        icon="pi pi-file-excel"
        severity="success"
        rounded
        onClick={() => exportExcelBtn("contact_data")}
        tooltip="Export to Excel"
        disabled={customers.length === 0}
      />
      <Button
        className="pdfbtn p-button me-2"
        icon="pi pi-file-pdf"
        severity="warning"
        rounded
        onClick={() => exportPdfBtn("contact_data")}
        disabled={customers.length === 0}
        tooltip="Export to PDF"
      />
    </div>
  )

  // Export Csv end
  useEffect(() => {
    if (visibleViewRight) {
      setShowPassword(false) // Ensure password is hidden when Sidebar is opened
    }
  }, [visibleViewRight])

  const [contactsActivityFilters, setContactsActivityFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    event_type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    event_sub_type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    event_time: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    event_priority: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    subject: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    "contact.first_name": {
      value: null,
      matchMode: FilterMatchMode.STARTS_WITH,
    },
    "company.company_name": {
      value: null,
      matchMode: FilterMatchMode.STARTS_WITH,
    },
    "contact.phone_number": {
      value: null,
      matchMode: FilterMatchMode.STARTS_WITH,
    },
    "contact.email": { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    "contact.category_name": {
      value: null,
      matchMode: FilterMatchMode.STARTS_WITH,
    },
    "contact.groups_name": {
      value: null,
      matchMode: FilterMatchMode.STARTS_WITH,
    },
    created_by_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    "contact.created_at": {
      value: null,
      matchMode: FilterMatchMode.STARTS_WITH,
    },
  })

  const [contactsTasksFilters, setContactsTasksFilters] = useState({
    event_type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    event_sub_type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    event_time: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    start_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    event_priority: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    subject: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    "contact.first_name": {
      value: null,
      matchMode: FilterMatchMode.STARTS_WITH,
    },
    "company.company_name": {
      value: null,
      matchMode: FilterMatchMode.STARTS_WITH,
    },
    "contact.phone_number": {
      value: null,
      matchMode: FilterMatchMode.STARTS_WITH,
    },
    "contact.email": { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    "contact.category_name": {
      value: null,
      matchMode: FilterMatchMode.STARTS_WITH,
    },
    "contact.groups_name": {
      value: null,
      matchMode: FilterMatchMode.STARTS_WITH,
    },
    created_by_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    "contact.updated_at": {
      value: null,
      matchMode: FilterMatchMode.STARTS_WITH,
    },
    "contact.created_at": {
      value: null,
      matchMode: FilterMatchMode.STARTS_WITH,
    },
  })

  const onInputChange = (e, field) => {
    const value = e.target.value
    setFilters(prevFilters => ({
      ...prevFilters,
      [field]: {
        ...prevFilters[field],
        value: value,
      },
    }))

    setContactsActivityFilters(prevFilters => ({
      ...prevFilters,
      [field]: {
        ...prevFilters[field],
        value: value,
      },
    }))

    setContactsTasksFilters(prevFilters => {
      // Ensure the field exists in the state
      if (!prevFilters[field]) {
        return prevFilters
      }
      return {
        ...prevFilters,
        [field]: {
          ...prevFilters[field],
          value: value,
        },
      }
    })
  }

  // documents treetable ends
  const navigate = useNavigate()
  const [selectedContact, setSelectedContact] = useState(null) // State to track the right-clicked contact

  // const toasts = useRef(null); // Reference for Toast notifications
  const cm = useRef(null) // Reference for ContextMenu

  const handleEdit = contact => {
    if (contact) {
      navigate(`/contacts-editform?id=${contact.id}`)
      // console.log("Edit contact:", contact);
    }
  }
  const handleDelete1 = ids => {
    if (Array.isArray(ids) && ids.length > 0) {
      setDeleteRowID(ids)
      setSmShow(true)
    }
  }
  const handleArchive1 = ids => {
    if (Array.isArray(ids) && ids.length > 0) {
      setSelectedRowIds(ids)
      setShowArchiveConfirm(true)
    }
  }
  const handleUnArchive1 = ids => {
    if (Array.isArray(ids) && ids.length > 0) {
      setSelectedRowIds(ids)
      setShowUnArchiveConfirm(true)
    }
  }

  const [emailDialogMode, setEmailDialogMode] = useState(null)
  const [showEmailDialog, setShowEmailDialog] = useState(false)

  const openScheduleDialog = optionLabel => {
    // Show warning if no contact is selected (for right-click/context menu)
    if (selectedCustomers.length === 0 && selectedContact) {
      setWarningDialogVisible(true)
      return
    }
    const selectedOption = scheduleOptions.find(
      opt => opt.label === optionLabel
    )
    if (selectedOption) {
      handleScheduleChange(selectedOption, optionLabel, true)
    }
  }
  const generateContextMenuItems = () => {
    return scheduleOptions?.map(option => ({
      label: option?.label,
      command: () => openScheduleDialog(option.label),
    }))
  }

  const getSelectedIds = () =>
    selectedCustomers.length > 0
      ? selectedCustomers?.map(c => c.id)
      : selectedContact
        ? [selectedContact.id]
        : []

  const notesContactRef = useRef(null)
  const notesContactRef1 = useRef(null)
  const emailContactsRef = useRef(null)
  const moreACContactsRef = useRef()

  // Context menu options
  const menuModel = selectedStatus === "Active" ? [
    ...(selectedCustomers.length <= 1
      ? [
        {
          label: "View",
          icon: "pi pi-fw pi-eye",
          visible: viewPermission,
          command: () => {
            const contact =
              selectedCustomers.length === 1
                ? selectedCustomers[0]
                : selectedContact
            if (contact) {
              const contactId = contact.id
              handleView(contactId)
              fetchPipeline(contactId)
              fetchDocuments(contactId)
              fetchNotes(contactId)
              fetchActivities(contactId)
              fetchhistory(contactId)
            }
          },
        },
      ]
      : []),
    ...(selectedCustomers.length <= 1
      ? [
        {
          label: "Edit",
          icon: "pi pi-fw pi-pencil",
          visible: editPermission,
          command: () => {
            const contact =
              selectedCustomers.length === 1
                ? selectedCustomers[0]
                : selectedContact
            handleEdit(contact)
          },
        },
      ]
      : []),
    param === "archived_only=true"
      ? {
        label: "Unarchive",
        icon: "pi pi-undo",
        command: () => handleUnArchive1(getSelectedIds()),
      }
      : {
        label: "Archive",
        icon: "pi pi-check-circle",
        command: () => handleArchive1(getSelectedIds()),
      },
    {
      label: "Delete",
      icon: "pi pi-fw pi-trash",
      visible: deletePermission,
      command: () => handleDelete1(getSelectedIds()),
    },
    {
      label: "Email",
      icon: "pi pi-envelope",
      items: [
        {
          label: "New Email",
          icon: "pi pi-calendar-plus",
          command: () => emailContactsRef.current?.openModal("new"),
        },
        {
          label: "Selected",
          icon: "pi pi-phone",
          command: () => emailContactsRef.current?.openModal("selected"),
        },
        {
          label: "Searched",
          icon: "pi pi-users",
          command: () => emailContactsRef.current?.openModal("searched"),
        },
        {
          label: "All",
          icon: "pi pi-list",
          command: () => emailContactsRef.current?.openModal("all"),
        },
        {
          label: "Jobs",
          icon: "pi pi-calendar-clock",
          items: [
            {
              label: "All",
              icon: "pi pi-calendar-plus",
              command: () => emailContactsRef.current?.openModal("jobs-all"),
            },
            {
              label: "Searched",
              icon: "pi pi-users",
              command: () =>
                emailContactsRef.current?.openModal("jobs-searched"),
            },
            {
              label: "Selected",
              icon: "pi pi-phone",
              command: () =>
                emailContactsRef.current?.openModal("jobs-selected"),
            },
          ],
        },
      ],
    },
    {
      label: "Schedule",
      icon: "pi pi-calendar-clock",
      items: generateContextMenuItems(),
    },
    { label: "SMS", icon: "pi pi-inbox" },
    {
      label: "Contacts Notes",
      icon: "pi pi-clipboard",
      visible: addPermission,
      command: () => {
        setTimeout(() => {
          if (selectedCustomers.length > 0) {
            notesContactRef1.current?.openLinkJobModal()
          } else {
            notesContactRef.current?.openLinkJobModal()
          }
        }, 0)
      },
    },
    {
      label: "Clear Search",
      icon: "pi pi-filter-slash",
      command: () => handleClearSearchContacts(),
    },
    {
      label: "More",
      icon: "pi pi-ellipsis-h",
      items: [
        {
          label: "Attachments",
          icon: "pi pi-link",
          command: () => moreACContactsRef.current?.openAttachments(),
        },
        {
          label: "Change Status",
          icon: "pi pi-sync",
          command: () => moreACContactsRef.current?.openChangeStatus(),
        },
      ],
    },
  ] : [
    {
      label: "Change Status",
      icon: "pi pi-sync",
      command: () => moreACContactsRef.current?.openChangeStatus(),
    },
  ]


  const currentDate = new Date()
  const currentTime = new Date()

  const updateSelectedCustomers = updatedCustomers => {
    setSelectedCustomers(updatedCustomers)
  }

  const [labels, setLabels] = useState([]);
  const fetchLabels = async () => {
    try {
      const response = await axios.get("/api/v1/get-all-address-label/");
      const labelsData = response.data.results || response.data || [];
      setLabels(
        labelsData?.map(item => ({
          name: item?.address_label,
          id: item?.id,
        }))
      );
    } catch (error) {
      console.error("Error fetching labels:", error);
      triggerAlert("error", "Error", "Failed to fetch address labels");
      setLabels([]);
    }
  };
  useEffect(() => {
    if (contactSidebarVisible) {
      fetchLabels();
    }
  }, [contactSidebarVisible]);

  const [allDocumentTypes, setAllDocumentTypes] = useState([]);

  const fetchAllDocumentTypes = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-document-type/`);
      setAllDocumentTypes(response.data.results || []);
    } catch (error) {
      setAllDocumentTypes([]);
    }
  };

  // Fetch document types when opening the view sidebar
  useEffect(() => {
    if (visibleViewRight) {
      fetchAllDocumentTypes();
    }
  }, [visibleViewRight]);




  const [empObjData, setEmpObjData] = useState([])

  const getDepartments = async () => {


    try {
      const response = await axios.get(`/api/v1/contacts/?company_id=${companyId}`);
      const response_data = response.data
      if (response_data) {
        console.log("DeptObjData", "2");
        setEmpObjData(response_data)


      } else {
      }
    } catch (error) {
    }
  }

// useEffect(() => {
//   getallactivecontacts(
//     lazyParamsContacts.page,
//     lazyParamsContacts.rows
//   )
// }, [lazyParamsContacts])

  const tableColumns = columns?.map(col => ({
  name: col.header,
  selector: row => row[col.field],
  sortable: true,
  cell: col.body
    ? row => col.body(row)
    : row => renderCell(row[col.field], col.header)
}));
useEffect(() => {
  if (companyId) {
    getallactivecontacts(currentPage, rowsPerPage);
    setSearchQuery("")
  }
}, [companyId, currentPage, rowsPerPage, selectedStatus]);

  return (
    <React.Fragment>
      <div className="page-content allact-tabs">
        <Container fluid={true}>
          <div className="page-title-box">
            <Row>
              <Col xxl={4} className="mt-2">
              <div className="d-flex justify-content-start align-items-center">
                <h1 className="page-title mb-1">All Employees</h1>
                </div>
                </Col>
              <Col xxl={8} className="text-end">
                 <div className="d-flex justify-content-end align-items-center">
                  <div className="me-2">
                    <label className="me-2">Select Company</label>
                    <div style={{ width: "200px", display: "inline-block" }}>
                      <CompanySelector onCompanyChange={handleCompanyChange} />
                    </div>
                  </div>
                 <div className="me-2 mb-3 mt-1" style={{ width: "250px" }}>
                      <InputGroup>
                        <Input
                          style={{ fontSize: "15px" }}
                          placeholder="Search Name or Email..."
                          value={searchQuery}
                          onChange={(e) => {
                            setSearchQuery(e.target.value);
                             if (e.target.value?.trim() === "") {
                                  setCurrentPage(1);
                                  getallactivecontacts(1, rowsPerPage, "");
                                }
                            }}
                           onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              setCurrentPage(1);
                              getallactivecontacts(1, rowsPerPage, searchQuery);
                            }
                          }}
                        />
                        {searchQuery !== "" && (
                          <InputGroupText
                            style={{
                              cursor: "pointer",
                              background: "transparent",
                              borderLeft: "none",
                            }}
                           onClick={() => {
                              setSearchQuery("");
                              setCurrentPage(1);
                              getallactivecontacts(1, rowsPerPage, "");
                            }}

                          >
                            <FaTimes style={{ fontSize: "14px", color: "#6c757d" }} />
                          </InputGroupText>
                        )}
                        <Button
                          style={{ fontSize: "15px" }}
                          className="btn searchIconBtn"
                         onClick={() => {
                            setCurrentPage(1);
                            getallactivecontacts(1, rowsPerPage, searchQuery);
                          }}
                        >
                          <i className="fa fa-search" />
                        </Button>
                      </InputGroup>
                    </div>


                </div>
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <section className="allactjobs-table">
                  {/* <div className='MyMarginCls'></div> */}
                  <Toast ref={toast} />
                  {/* ContextMenu for right-click actions */}
                  {/* <ContextMenu
                    model={menuModel}
                    ref={cm}
                    onHide={() => setSelectedContact(null)}
                  /> */}
                  <div className="card1 mt-1 mb-4 actjobsumtable">
                    {dataLoading ? (
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{ minHeight: 300 }}
                        >
                        <OrgTableShimmer columns={6} rows={7} titleWidth="220px" />
                        </div>
                    ) : type === "activity-log" ? (
                      <DataTable
                        value={customers}
                        paginator
                        lazy
                        first={first}
                        rows={rows}
                        totalRecords={totalRecords}
                        onPage={onPageChange}
                        loading={loading}
                        responsiveLayout="scroll"
                        showGridlines
                        tableStyle={{
                          minWidth: "60rem",
                          borderRadius: "8px",
                          boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                        }}
                        filters={contactsActivityFilters}
                        filterDisplay="row"
                        globalFilterFields={[
                          "event_type",
                          "event_sub_type",
                          "event_time",
                          "event_priority",
                          "subject",
                          "status",
                          "start_date",
                          "end_date",
                          "contact.first_name",
                          "contact.company_name",
                          "contact.phone_number",
                          "contact.email",
                          "contact.category_name",
                          "contact.groups_name",
                          "created_by_name",
                          "contact.created_at",
                        ]}
                        emptyMessage="No contacts activity found."
                        // selection={selectedCustomers}
                        // onSelectionChange={onSelectionChange}
                        // selection={selectedContactsActivity}
                        // onSelectionChange={(e) => setSelectedContactsActivity(e.value)}
                        // selectionMode="multiple"
                        resizableColumns
                        reorderableColumns
                        columnResizeMode="expand"
                        scrollable
                        // onContextMenu={e => {
                        //   cm.current.show(e.originalEvent) // Show the context menu
                        //   setSelectedContact(e.data) // Set the selected contact
                        // }}
                        // contextMenuSelection={selectedContact}
                        // onContextMenuSelectionChange={e =>
                        //   setSelectedContact(e.value)
                        // }
                      >
                        {/* <Column
                          selectionMode="multiple"
                          headerStyle={{ width: "3em" }}
                        /> */}
                        <Column
                          field="event_type"
                          header="Activity Type"
                          frozen
                          sortable
                          filter
                          style={{ minWidth: "10rem" }}
                          filterElement={options => (
                            <InputText
                              value={options.value || ""}
                              onChange={e => onInputChange(e, "event_type")}
                              placeholder="Search by activity type"
                            />
                          )}
                        />
                        <Column
                          field="event_sub_type"
                          header="Sub-Type"
                          sortable
                          filter
                          style={{ minWidth: "10rem" }}
                          filterElement={options => (
                            <InputText
                              value={options.value || ""}
                              onChange={e => onInputChange(e, "event_sub_type")}
                              placeholder="Search by sub type"
                            />
                          )}
                        />

                        <Column
                          field="event_time"
                          header="Activity Date"
                          sortable
                          filter
                          style={{ minWidth: "10rem" }}
                          filterElement={options => (
                            <InputText
                              value={options.value || ""}
                              onChange={e => onInputChange(e, "event_time")}
                              placeholder="Search by action date"
                              dateFormat="dd/mm/yy"
                            />
                          )}
                          body={rowData =>
                            rowData.event_time
                              ? moment
                                .utc(rowData.event_time)
                                .format("DD/MM/YYYY HH:mm A")
                              : ""
                          }
                        />

                        <Column
                          field="event_priority"
                          header="Priority"
                          sortable
                          filter
                          style={{ minWidth: "10rem" }}
                          filterElement={options => (
                            <InputText
                              value={options.value || ""}
                              onChange={e => onInputChange(e, "event_priority")}
                              placeholder="Search by priority"
                            />
                          )}
                        />
                        <Column
                          field="subject"
                          header="Subject"
                          sortable
                          filter
                          style={{ minWidth: "10rem" }}
                          filterElement={options => (
                            <InputText
                              value={options.value || ""}
                              onChange={e => onInputChange(e, "subject")}
                              placeholder="Search by subject"
                            />
                          )}
                        />

                        <Column
                          field="status"
                          header="Status"
                          sortable
                          filter
                          style={{ minWidth: "10rem" }}
                          filterElement={options => (
                            <InputText
                              value={options.value || ""}
                              onChange={e => onInputChange(e, "status")}
                              placeholder="Search by status"
                            />
                          )}
                        />

                        <Column
                          header="Contact Name"
                          sortable
                          filter
                          filterField="contact.first_name"
                          body={rowData => {
                            const { first_name, middle_name, last_name } =
                              rowData.contact || {}
                            return `${first_name || ""} ${middle_name || ""} ${last_name || ""
                              }`.trim()
                          }}
                          filterElement={options => (
                            <InputText
                              value={options.value || ""}
                              onChange={e =>
                                options.filterApplyCallback(e.target.value)
                              }
                              placeholder="Search by contact name"
                            />
                          )}
                        />

                        <Column
                          header="Company"
                          sortable
                          filter
                          filterField="company.company_name"
                          body={rowData => rowData.company?.company_name || ""}
                          style={{ minWidth: "10rem" }}
                          filterElement={options => (
                            <InputText
                              value={options.value || ""}
                              onChange={e =>
                                onInputChange(e, "company.company_name")
                              }
                              placeholder="Search by company name"
                            />
                          )}
                        />

                        <Column
                          header="Phone"
                          sortable
                          filter
                          filterField="contact.phone_number"
                          body={rowData => rowData.contact?.phone_number || ""}
                          style={{ minWidth: "10rem" }}
                          filterElement={options => (
                            <InputText
                              value={options.value || ""}
                              onChange={e =>
                                onInputChange(e, "contact.phone_number")
                              }
                              placeholder="Search by phone"
                            />
                          )}
                        />

                        <Column
                          header="Email"
                          sortable
                          filter
                          filterField="contact.email"
                          body={rowData => rowData.contact?.email || ""}
                          style={{ minWidth: "10rem" }}
                          filterElement={options => (
                            <InputText
                              value={options.value || ""}
                              onChange={e => onInputChange(e, "contact.email")}
                              placeholder="Search by email"
                            />
                          )}
                        />

                        <Column
                          header="Categories"
                          sortable
                          filter
                          filterField="contact.category_name"
                          body={rowData => rowData.contact?.category_name || ""}
                          style={{ minWidth: "10rem" }}
                          filterElement={options => (
                            <InputText
                              value={options.value || ""}
                              onChange={e =>
                                onInputChange(e, "contact.category_name")
                              }
                              placeholder="Search by categories"
                            />
                          )}
                        />

                        <Column
                          header="Groups"
                          sortable
                          filter
                          filterField="contact.groups_name"
                          body={rowData => rowData.contact?.groups_name || ""}
                          style={{ minWidth: "10rem" }}
                          filterElement={options => (
                            <InputText
                              value={options.value || ""}
                              onChange={e =>
                                onInputChange(e, "contact.groups_name")
                              }
                              placeholder="Search by groups"
                            />
                          )}
                        />
                        {/* <Column
                          field="subject"
                          header="Subject"
                          sortable
                          filter
                          style={{ minWidth: "10rem" }}
                          filterElement={(options) => (
                            <InputText
                              value={options.value || ''}
                              onChange={(e) => onInputChange(e, 'subject')}
                              placeholder="Search by subject"
                            />
                          )}
                        /> */}

                        <Column
                          header="Created By"
                          sortable
                          filter
                          field="created_by_name"
                          // body={(rowData) => rowData.contact?.created_by_name || ''}
                          style={{ minWidth: "10rem" }}
                          filterElement={options => (
                            <InputText
                              value={options.value || ""}
                              onChange={e =>
                                onInputChange(e, "created_by_name")
                              }
                              placeholder="Search by created by"
                            />
                          )}
                        />
                        <Column
                          header="Create Date"
                          sortable
                          filter
                          filterField="contact.created_at"
                          body={rowData =>
                            rowData.contact?.created_at
                              ? moment(rowData.contact.created_at).format(
                                "YYYY-MM-DD"
                              )
                              : ""
                          }
                          style={{ minWidth: "10rem" }}
                          filterElement={options => (
                            <InputText
                              value={options.value || ""}
                              onChange={e =>
                                onInputChange(e, "contact.created_at")
                              }
                              placeholder="Search by create date "
                            />
                          )}
                        />

                        {/* <Column field="create_date" header="Create Date" sortable filter style={{ minWidth: "10rem" }} />  */}
                      </DataTable>
                    ) : type === "task-list" ? (
                      <DataTable
                        //  dataKey="id"
                        value={allC}
                        paginator
                        lazy
                        first={first}
                        rows={rows}
                        totalRecords={totalRecords}
                        onPage={onPageChange}
                        loading={loading}
                        responsiveLayout="scroll"
                        showGridlines
                        tableStyle={{
                          minWidth: "60rem",
                          borderRadius: "8px",
                          boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                        }}
                        filters={contactsTasksFilters}
                        filterDisplay="row"
                        globalFilterFields={[
                          "type",
                          "sub_type",
                          "start_date_time",
                          "priority",
                          "subject",
                          "status",
                          "contact.first_name",
                          "contact.company_name",
                          "contact.phone_number",
                          "contact.email",
                          "contact.category_name",
                          "contact.groups_name",
                          "created_by_name",
                          "contact.updated_at",
                          "contact.created_at",
                        ]}
                        emptyMessage="No contacts tasks found."
                        // selection={selectedCustomers}
                        // onSelectionChange={onSelectionChange}
                        // selectionMode="multiple"
                        resizableColumns
                        reorderableColumns
                        columnResizeMode="expand"
                        // onContextMenu={e => {
                        //   cm.current.show(e.originalEvent)
                        //   setSelectedContact(e.data)
                        // }}
                        // contextMenuSelection={selectedContact}
                        // onContextMenuSelectionChange={e =>
                        //   setSelectedContact(e.value)
                        // }
                      >
                        {/* <Column
                          selectionMode="multiple"
                          headerStyle={{ width: "3em" }}
                        /> */}
                        <Column
                          field="event_type"
                          header="Type"
                          sortable
                          filter
                          style={{ minWidth: "10rem" }}
                          filterElement={options => (
                            <InputText
                              value={options.value || ""}
                              onChange={e => onInputChange(e, "event_type")}
                              placeholder="Search by type"
                            />
                          )}
                        />
                        <Column
                          field="event_sub_type"
                          header="Sub-Type"
                          sortable
                          filter
                          style={{ minWidth: "10rem" }}
                          filterElement={options => (
                            <InputText
                              value={options.value || ""}
                              onChange={e => onInputChange(e, "event_sub_type")}
                              placeholder="Search by sub type"
                            />
                          )}
                        />
                        <Column
                          field="event_time"
                          header="Start Date Time"
                          sortable
                          filter
                          style={{ minWidth: "12rem" }}
                          filterElement={options => (
                            <InputText
                              value={options.value || null}
                              onChange={e => onInputChange(e, "event_time")}
                              placeholder="Search by start date time"
                            />
                          )}
                          body={rowData =>
                            rowData.event_time
                              ? moment
                                .utc(rowData.event_time)
                                .format("YYYY-MM-DD HH:mm A")
                              : ""
                          }
                        // body={(rowData) => {
                        //   const eventTime = rowData.event_time;
                        //   const dateOnly = eventTime.split("T")[0];
                        //   const timeOnly = eventTime.split("T")[1].slice(0, 5);
                        //   return `${dateOnly} ${timeOnly}`;
                        // }}
                        />
                        <Column
                          field="event_priority"
                          header="Priority"
                          sortable
                          filter
                          style={{ minWidth: "10rem" }}
                          filterElement={options => (
                            <InputText
                              value={options.value || ""}
                              onChange={e => onInputChange(e, "event_priority")}
                              placeholder="Search by priority"
                            />
                          )}
                        />
                        <Column
                          field="subject"
                          header="Subject"
                          sortable
                          filter
                          style={{ minWidth: "12rem" }}
                          filterElement={options => (
                            <InputText
                              value={options.value || ""}
                              onChange={e => onInputChange(e, "subject")}
                              placeholder="Search by subject"
                            />
                          )}
                        />
                        <Column
                          field="status"
                          header="Status"
                          sortable
                          filter
                          style={{ minWidth: "10rem" }}
                          filterElement={options => (
                            <InputText
                              value={options.value || ""}
                              onChange={e => onInputChange(e, "status")}
                              placeholder="Search by status"
                            />
                          )}
                        />
                        <Column
                          header="Contact Name"
                          sortable
                          filter
                          filterField="contact.first_name"
                          body={rowData => {
                            const { first_name, middle_name, last_name } =
                              rowData.contact || {}
                            return `${first_name || ""} ${middle_name || ""} ${last_name || ""
                              }`.trim()
                          }}
                          filterElement={options => (
                            <InputText
                              value={options.value || ""}
                              onChange={e =>
                                options.filterApplyCallback(e.target.value)
                              }
                              placeholder="Search by contact name"
                            />
                          )}
                        />

                        <Column
                          header="Company"
                          sortable
                          filter
                          filterField="company.company_name"
                          body={rowData => rowData.company?.company_name || ""}
                          style={{ minWidth: "10rem" }}
                          filterElement={options => (
                            <InputText
                              value={options.value || ""}
                              onChange={e =>
                                onInputChange(e, "company.company_name")
                              }
                              placeholder="Search by company name"
                            />
                          )}
                        />

                        <Column
                          header="Phone"
                          sortable
                          filter
                          filterField="contact.phone_number"
                          body={rowData => rowData.contact?.phone_number || ""}
                          style={{ minWidth: "10rem" }}
                          filterElement={options => (
                            <InputText
                              value={options.value || ""}
                              onChange={e =>
                                onInputChange(e, "contact.phone_number")
                              }
                              placeholder="Search by phone"
                            />
                          )}
                        />

                        <Column
                          header="Email"
                          sortable
                          filter
                          filterField="contact.email"
                          body={rowData => rowData.contact?.email || ""}
                          style={{ minWidth: "10rem" }}
                          filterElement={options => (
                            <InputText
                              value={options.value || ""}
                              onChange={e => onInputChange(e, "contact.email")}
                              placeholder="Search by email"
                            />
                          )}
                        />

                        <Column
                          header="Categories"
                          sortable
                          filter
                          filterField="contact.category_name"
                          body={rowData => rowData.contact?.category_name || ""}
                          style={{ minWidth: "10rem" }}
                          filterElement={options => (
                            <InputText
                              value={options.value || ""}
                              onChange={e =>
                                onInputChange(e, "contact.category_name")
                              }
                              placeholder="Search by categories"
                            />
                          )}
                        />

                        <Column
                          header="Groups"
                          sortable
                          filter
                          filterField="contact.groups_name"
                          body={rowData => rowData.contact?.groups_name || ""}
                          style={{ minWidth: "10rem" }}
                          filterElement={options => (
                            <InputText
                              value={options.value || ""}
                              onChange={e =>
                                onInputChange(e, "contact.groups_name")
                              }
                              placeholder="Search by groups"
                            />
                          )}
                        />

                        <Column
                          header="Create Date"
                          sortable
                          filter
                          filterField="contact.created_at"
                          body={rowData =>
                            rowData.contact?.created_at
                              ? moment(rowData.contact.created_at).format(
                                "YYYY-MM-DD"
                              )
                              : ""
                          }
                          style={{ minWidth: "10rem" }}
                          filterElement={options => (
                            <InputText
                              value={options.value || ""}
                              onChange={e =>
                                onInputChange(e, "contact.created_at")
                              }
                              placeholder="Search by create date "
                            />
                          )}
                        />
                        <Column
                          header="Edit Date"
                          sortable
                          filter
                          filterField="contact.updated_at"
                          body={rowData =>
                            rowData.contact?.updated_at
                              ? moment(rowData.contact.updated_at).format(
                                "YYYY-MM-DD"
                              )
                              : ""
                          }
                          style={{ minWidth: "10rem" }}
                          filterElement={options => (
                            <InputText
                              value={options.value || ""}
                              onChange={e =>
                                onInputChange(e, "contact.updated_at")
                              }
                              placeholder="Search by edit date"
                            />
                          )}
                        />
                        <Column
                          header="Created By"
                          sortable
                          filter
                          field="created_by_name"
                          // body={(rowData) => rowData.contact?.created_by_name || ''}
                          style={{ minWidth: "10rem" }}
                          filterElement={options => (
                            <InputText
                              value={options.value || ""}
                              onChange={e =>
                                onInputChange(e, "created_by_name")
                              }
                              placeholder="Search by created by"
                            />
                          )}
                        />
                      </DataTable>
                    ) : (  
                      <>                      
                    <div id="AllLoginActivitysCandy_TableView">
                      <DataTable
                        columns={tableColumns}
                        key={tableKey}       
                        data={allcontacts}
                        progressPending={loading1}
                        pagination
                        paginationServer
                        progressComponent={<CustomLoader />}
                        paginationTotalRows={totalRecordsContacts}
                        paginationPerPage={rowsPerPage}
                        paginationDefaultPage={currentPage}
                        paginationDefaultPerPage={10}
                        onChangePage={handlePageChange}
                        onChangeRowsPerPage={handlePerRowsChange}
                        paginationRowsPerPageOptions={[10, 20, 50]}
                        highlightOnHover
                        striped
                        persistTableHead
                        fixedHeader
                        fixedHeaderScrollHeight="600px"
                        paginationComponentOptions={paginationComponentOptions}
                        // noDataComponent="No contacts found."
                        
                      />
                      </div>
                      </>
                    )}
                  </div>
                </section>
              </Col>
            </Row>

            {/* Side bar start */}
            <Row>
              <Col lg={12}>
                {/* <div className="flex gap-2 justify-content-center">

                  <Button icon="pi pi-arrow-left" onClick={() => setVisibleRight(true)} />
                </div> */}

                <Sidebar
                  visible={contactSidebarVisible}
                  position="right"
                  className="sidebar"
                  onHide={() => {
                    dispatch(setContactSidebarVisible(false))
                    reset()
                    clearErrors()
                    setAddress("")
                    setSelectedCompany([])
                    setSelectedCountry(null)
                    setSelectedState(null)
                    setSelectedCity(null)
                    setSelectedCategoryKey(null)
                    setSelectedGroupKey(null)
                    setisEdited(false)
                    setSelectedLabel(null)
                  }}
                >
                  <div className="sidebar-header">
                    <h3>Create a Contact</h3>
                    <div className="d-flex align-items-center">
                      <Button
                        icon="pi pi-times"
                        className="p-button-text close-btn"
                        onClick={() => dispatch(setContactSidebarVisible(false))}
                      />
                    </div>
                  </div>
                  <div className="card sidebardetails">
                    <form>
                      <Row className="mb-3">
                        <Col lg={6}>
                          <div className="p-field">
                            <label htmlFor="firstName">
                              First Name<span style={{ color: "red" }}>*</span>
                            </label>
                            <InputText
                              id="firstName"
                              placeholder="Enter first name"
                              {...register("firstname", {
                                required: "First name is required",
                                pattern: {
                                  value: /^[A-Za-z][A-Za-z-\s&]+$/,
                                  message:
                                    "This field allows only alphabets and spaces, but does not accept a space as the first character.",
                                },
                              })}
                              onKeyUp={() => {
                                trigger("firstname")
                              }}
                            />
                            {errors.firstname && (
                              <small
                                id="personalEmailHelp"
                                className="form-text text-danger"
                              >
                                {errors.firstname.message}
                              </small>
                            )}
                          </div>
                        </Col>
                        {/* <Col lg={4}>
                          <label htmlFor="firstName">Middle Name</label>
                          <InputText
                            placeholder="Enter middle name"
                            {...register("middlename", {
                              // required: "middle name is required",
                              pattern: {
                                value: /^[A-Za-z][A-Za-z-\s&]+$/,
                                message:
                                  "This field allows only alphabets and spaces, but does not accept a space as the first character.",
                              },

                            })}
                            onKeyUp={() => { trigger("middlename") }}
                          />
                          {errors.middlename && (<small id='personalEmailHelp' className='form-text text-danger'>{errors.middlename.message}</small>)}
                        </Col> */}
                        <Col lg={6}>
                          <div className="p-field">
                            <label htmlFor="lastName">Last Name</label>
                            <InputText
                              id="lastName"
                              placeholder="Enter last name"
                              {...register("lastname", {
                                // required: "last name is required",
                                pattern: {
                                  value: /^[A-Za-z][A-Za-z-\s&]+$/,
                                  message:
                                    "This field allows only alphabets and spaces, but does not accept a space as the first character.",
                                },
                              })}
                              onKeyUp={() => {
                                trigger("lastname")
                              }}
                            />
                            {errors.lastname && (
                              <small
                                id="personalEmailHelp"
                                className="form-text text-danger"
                              >
                                {errors.lastname.message}
                              </small>
                            )}
                          </div>
                        </Col>
                      </Row>

                      <Row className="mb-4">
                        <Col lg={6}>
                          <div className="p-field">
                            <label htmlFor="email">
                              Email<span style={{ color: "red" }}>*</span>
                            </label>
                            <InputText
                              type="email"
                              placeholder="Enter your email"
                              {...register("personal_email", {
                                required: "Please enter  Email",
                                pattern: {
                                  value:
                                    /^[A-Z0-9._%+-]+@[A-Z.-]{2,}\.+[A-Z]{2,}$/i,
                                  message: "Please enter valid Email", // JS only: <p>error message</p> TS only support string
                                },
                                onChange: event =>
                                (event.target.value =
                                  event.target.value.toLowerCase()),
                              })}
                            />

                            {errors.personal_email && (
                              <small
                                id="personalEmailHelp"
                                className="form-text text-danger"
                              >
                                {errors.personal_email.message}
                              </small>
                            )}
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="p-field">
                            <label htmlFor="phoneNumber">Phone Number</label>
                            <InputText
                              placeholder="Enter phone number"
                              {...register("Phone", {
                                // required: "This field is required",
                                pattern: {
                                  value:
                                    /^(?:(?:\+|0{0,2})91(\s*|[\-])?|[0]?)?([6789]\d{2}([ -]?)\d{3}([ -]?)\d{4})$/,
                                  message:
                                    "Please enter a valid mobile number.",
                                },
                                minLength: {
                                  value: 10,
                                  message:
                                    "Please enter Min and Max 10 digits ",
                                },
                                maxLength: {
                                  value: 10,
                                  message:
                                    "Please enter Min and Max 10 digits ",
                                },
                              })}
                              onKeyUp={e => {
                                trigger("Phone")
                              }}
                            />{" "}
                            {errors.Phone && (
                              <small
                                id="phoneNoHelp"
                                className="form-text text-danger"
                              >
                                {errors.Phone.message}
                              </small>
                            )}
                          </div>
                        </Col>
                      </Row>
                      <Row className="mb-3">
                        <Col lg={6}>
                          <label htmlFor="username">Username</label>
                          <InputText
                            placeholder="Enter username"
                            {...register("username", {
                              pattern: {
                                value: /^[a-z]{1,30}$/, // only lowercase letters, length 1 to 30
                                message:
                                  "Only lowercase letters are allowed. No numbers or spaces. Max 30 characters.",
                              },
                              maxLength: {
                                value: 30,
                                message:
                                  "Username cannot exceed 30 characters.",
                              },
                            })}
                            onKeyUp={() => {
                              trigger("username")
                            }}
                          />
                          {errors.username && (
                            <small
                              id="personalEmailHelp"
                              className="form-text text-danger"
                            >
                              {errors.username.message}
                            </small>
                          )}
                        </Col>

                        <Col lg={6}>
                          <div className="p-field">
                            <label htmlFor="password">Password</label>
                            <div className="p-inputgroup w-100">
                              <InputText
                                id="password"
                                type={showPassword ? "text" : "password"}
                                className="w-100"
                                placeholder="Enter password"
                                value={getValues("password") || ""}
                                {...register("password", {
                                  pattern: {
                                    value: /^\S*$/, // no spaces
                                    message: "Password cannot contain spaces",
                                  },
                                  minLength: {
                                    value: 8,
                                    message:
                                      "Password must be at least 8 characters long",
                                  },
                                  maxLength: {
                                    value: 25,
                                    message:
                                      "Password cannot exceed 25 characters",
                                  },
                                })}
                                onChange={e =>
                                  setValue("password", e.target.value)
                                }
                                onKeyUp={() => trigger("password")}
                              />
                              <Button
                                icon={
                                  showPassword ? "pi pi-eye" : "pi pi-eye-slash"
                                }
                                className="p-button-text"
                                type="button"
                                onClick={() => setShowPassword(prev => !prev)}
                              />
                            </div>
                            {errors.password && (
                              <small
                                id="passwordHelp"
                                className="form-text text-danger"
                              >
                                {errors.password.message}
                              </small>
                            )}
                          </div>
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Col lg={6}>
                          <div className="p-field">
                            <label htmlFor="jobTitle" className="p-d-block">
                              Designation
                            </label>
                            <InputText
                              placeholder="Job Title"
                              className="p-d-block"
                              {...register("jobtitle", {
                                // required: "This field is required",
                                pattern: {
                                  value: /^[a-zA-Z_ ]*$/,
                                  message: "Please enter valid Job Tittle ",
                                },
                              })}
                              onKeyUp={() => {
                                trigger("jobtitle")
                              }}
                            />
                            {errors.jobtitle && (
                              <small
                                id="emailHelp"
                                className="form-text text-danger"
                              >
                                {errors.jobtitle.message}
                              </small>
                            )}
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="p-field">
                            <label htmlFor="company">Company</label>
                            <Dropdown
                              id="company"
                              value={selectedCompany} // This binds the selected company id
                              options={companies} // This binds the companies array
                              onChange={e => setSelectedCompany(e.value)} // Update the selected company id
                              placeholder="Select Company"
                              optionLabel="name" // Display company name
                              filter // Enable search functionality
                              filterBy="name" // Search by company name
                              className="w-full activejobdrop"
                            />
                          </div>
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Col lg={6}>
                          <div className="p-field">
                            <label htmlFor="company">Department</label>
                            <select
                              className="form-select profileDetailsInput"
                              id="MyPro_EmpDet_Team_WorkInfo_DesSelBox"
                              aria-label="Default select example"
                              {...register("department", {
                                // required: "This field is required",
                              })}
                            >
                              <option value="">--Select --</option>
                              {departitems?.map((item, j) => {
                                return (
                                  <option value={item?.department_id} key={j}>
                                    {item?.name}
                                  </option>
                                )
                              })}
                            </select>
                            {/* {errors.department && (<small id='emailHelp' className='form-text text-danger'>{errors.department.message}</small>)} */}
                          </div>
                        </Col>

                        <Col lg={6}>
                          <div className="p-field">
                            <label htmlFor="company">Reporting Person</label>
                            <select
                              className="form-select profileDetailsInput"
                              id="MyPro_EmpDet_Team_WorkInfo_DesSelBox"
                              aria-label="Default select example"
                              {...register("Related", {
                                // required: "This field is required",
                              })}
                            >
                              <option value="">--Select --</option>
                              {relatedPerson?.map((item, j) => {
                                return (
                                  <option value={item?.id} key={j}>
                                    {item?.first_name || ""}{" "}
                                    {item?.middle_name || ""}{" "}
                                    {item?.last_name || ""}
                                  </option>
                                )
                              })}
                            </select>

                            {/* {errors.Related && (<small id='emailHelp' className='form-text text-danger'>{errors.Related.message}</small>)} */}
                          </div>
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Col lg={12}>
                          <div
                            className="p-field companie-add"
                            style={{ position: "relative" }}
                          >
                            <label htmlFor="address">Address</label>
                            <InputTextarea
                              id="address"
                              value={address}
                              readOnly
                              placeholder="Enter your address"
                              style={{ paddingRight: "2rem" }}
                              rows={3}
                              cols={30}
                            />

                            {/* Edit Icon */}
                            <i
                              className="pi pi-pencil"
                              style={{
                                position: "absolute",
                                right: "10px",
                                top: "70%",
                                transform: "translateY(-50%)",
                                color: "#6c757d",
                                cursor: "pointer",
                              }}
                              onClick={() => setVisible(true)}
                            ></i>
                            <Dialog
                              header="Edit Address"
                              className="address-popup"
                              visible={visible}
                              onHide={() => {
                                if (!visible) return
                                setVisible(false)
                                setStreet1("")
                                setStreet2("")
                                setPostalCode("")
                                setSelectedCountry(null)
                                setSelectedState(null)
                                setSelectedCity(null)
                                setSelectedLabel(null)
                              }}
                              style={{ width: "30vw" }}
                              breakpoints={{
                                "960px": "75vw",
                                "641px": "100vw",
                              }}
                            >
                              <div className="card sidebardetails">
                                <form>
                                  <Row className="mb-3">
                                    <Col lg={6}>
                                      <div className="p-field">
                                        <label htmlFor="street1">
                                          Street 1
                                        </label>
                                        <InputText
                                          id="street1"
                                          value={street1}
                                          onChange={e => {
                                            setStreet1(e.target.value)
                                          }}
                                          placeholder="Enter Street 1"
                                          className="w-full activejobdrop"
                                        />
                                      </div>
                                    </Col>
                                    <Col lg={6}>
                                      <label htmlFor="street2">Street 2</label>
                                      <InputText
                                        id="street2"
                                        value={street2}
                                        onChange={e => {
                                          setStreet2(e.target.value)
                                        }}
                                        placeholder="Enter Street 2 (Optional)"
                                        className="w-full activejobdrop"
                                      />
                                    </Col>
                                  </Row>

                                  <Row className="mb-3">
                                    <Col lg={6}>
                                      <label htmlFor="country">Country</label>
                                      <Dropdown
                                        value={selectedCountry}
                                        onChange={e => {
                                          setSelectedCountry(e.target.value)
                                        }}
                                        options={addCountries}
                                        optionLabel="name"
                                        filter
                                        filterPlaceholder="Search Country"
                                        className="w-full activejobdrop"
                                        placeholder="Enter country details..."
                                      />
                                    </Col>

                                    <Col lg={6}>
                                      <label htmlFor="state">State</label>
                                      <Dropdown
                                        id="state"
                                        value={selectedState}
                                        onChange={e => {
                                          setSelectedState(e.target.value)
                                        }}
                                        options={addStates}
                                        optionLabel="name"
                                        filter
                                        filterPlaceholder="Search State"
                                        className="w-full activejobdrop"
                                        placeholder="Enter state details..."
                                      />
                                    </Col>
                                  </Row>

                                  <Row className="mb-3">
                                    <Col lg={6}>
                                      <label htmlFor="city">City</label>
                                      <Dropdown
                                        id="city"
                                        value={selectedCity}
                                        onChange={e => {
                                          setSelectedCity(e.target.value)
                                        }}
                                        options={addCities}
                                        optionLabel="name"
                                        filter
                                        filterPlaceholder="Search City"
                                        className="w-full activejobdrop"
                                        placeholder="Enter city details..."
                                      />
                                    </Col>
                                    <Col lg={6}>
                                      <label htmlFor="postalCode">
                                        Postal Code
                                      </label>
                                      <InputText
                                        id="postalCode"
                                        value={postalCode}
                                        onChange={e => {
                                          const value = e.target.value
                                          // Allow only digits and limit to 6 characters
                                          if (/^\d{0,6}$/.test(value)) {
                                            setPostalCode(value)
                                          }
                                        }}
                                        maxLength={6}
                                        placeholder="Enter Postal Code"
                                        className="w-full activejobdrop"
                                        pattern="[0-9]{6}"
                                        inputMode="numeric" // Suggests numeric keyboard on mobile
                                        onKeyPress={e => {
                                          // Prevent non-digit characters
                                          if (!/[0-9]/.test(e.key)) {
                                            e.preventDefault()
                                          }
                                        }}
                                      />
                                    </Col>
                                  </Row>

                                  <Row className="mb-3">
                                    <Col lg={12}>
                                      <label htmlFor="postalCode">Label</label>
                                      <Dropdown
                                        value={selectedLabel}
                                        onChange={e => {
                                          setSelectedLabel(e.value)
                                        }}
                                        options={labels}
                                        optionLabel="name"
                                        placeholder="Select a Label"
                                        className="w-full activejobdrop"
                                      />
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col>
                                      <Button
                                        type="button"
                                        color="primary"
                                        className="btn btn-primary  waves-light me-2 sidebarbtn"
                                        onClick={() => setVisible(false)}
                                      >
                                        <i className="pi pi-check me-1"></i> Ok
                                      </Button>
                                    </Col>
                                  </Row>
                                </form>
                              </div>
                            </Dialog>
                          </div>
                        </Col>
                      </Row>

                      <Row className="mb-2">
                        <Col lg={6}>
                          <div className="p-field">
                            <label htmlFor="company">Categories</label>
                            <TreeSelect
                              value={selectedCategoryKey}
                              onChange={e => {
                                setSelectedCategoryKey(e.value)
                              }}
                              options={treeCategories}
                              // optionLabel="label"
                              // optionValue="key"
                              placeholder="Select Category"
                              className="w-full "
                            />
                          </div>
                        </Col>

                        <Col lg={6}>
                          <div className="p-field">
                            <label htmlFor="company">Groups</label>
                            <TreeSelect
                              value={selectedGroupKey}
                              onChange={e => setSelectedGroupKey(e.value)}
                              options={groupitem}
                              // optionLabel="label"
                              // optionValue="key"
                              placeholder="Select Group"
                              className="w-full activejobdrop"
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row className="d-flex align-items-end mb-2">
                        <Col lg={6}>
                          <div className="p-field">
                            <label htmlFor="jobType">UserIDs</label>
                            <InputText
                              value={uniqueUserId}
                              readOnly
                              placeholder="Select a User ID"
                              className="w-full activejobdrop"
                            />
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="private">
                            <input
                              type="checkbox"
                              {...register("private", {})}
                              onKeyUp={() => {
                                trigger("private")
                              }}
                              className="me-2"
                            />
                            <label htmlFor="private" className="mb-2">
                              Private
                            </label>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        {loading && (
                          <div className="flex justify-content-center align-items-center mt-3">
                            <ProgressSpinner />
                          </div>
                        )}
                      </Row>
                      <Row>
                        <Col>
                          <Button
                            type="submit"
                            color="primary"
                            className="btn btn-primary  waves-light me-2 sidebarbtn float-end"
                            disabled={loading || disable}
                          >
                            Create
                          </Button>
                        </Col>
                      </Row>
                    </form>
                  </div>
                </Sidebar>
              </Col>
            </Row>
            {/* Side bar end */}
          </div>
        </Container>
      </div>

      <Modal
        size="md"
        show={smShow}
        onHide={() => setSmShow(false)}
        className="text-center"
      >
        <Modal.Header closeButton>
          <h1 className="modal-title fs-5 "> Delete</h1>
        </Modal.Header>
        <div className="text-center m-3 text-danger"> </div>
        <h4 className="text-center m-2 p-2">
          {" "}
          Are you sure you want to delete this Contact{" "}
        </h4>
        <div className="text-center m-3">
          <Button
            className="btn btn-primary m-1"
            onClick={() => setSmShow(false)}
          >
            Cancel
          </Button>
          <button className="btn btn-primary m-1">
            {" "}
            Delete{" "}
          </button>
        </div>
      </Modal>

      <Modal
        size="md"
        show={successAlert}
        onHide={() => setSuccessAlert(false)}
        className="text-center"
      >
        <Modal.Header closeButton>
          <h1 className="modal-title fs-5">Success</h1>
        </Modal.Header>
        <div className="text-center m-3"></div>
        <h4 className="text-center">Delete Successfully</h4>
        <div className="text-center m-3">
          <button
            className="btn btn-primary"
            onClick={() => setSuccessAlert(false)}
          >
            OK
          </button>
        </div>
      </Modal>

      <Modal
        size="md"
        show={showArchiveConfirm}
        onHide={() => setShowArchiveConfirm(false)}
        className="text-center"
      >
        <Modal.Header closeButton>
          <h1 className="modal-title fs-5">Archive Confirmation</h1>
        </Modal.Header>
        <div className="text-center m-3 text-danger"></div>
        <h4 className="text-center">
          Are you sure you want to archive these contacts?
        </h4>
        <div className="text-center m-3">
          <Button
            className="btn btn-primary m-1"
            onClick={() => setShowArchiveConfirm(false)}
          >
            Cancel
          </Button>
          <Button className="btn btn-primary m-1" >
            Archive
          </Button>
        </div>
      </Modal>

      <Modal
        size="md"
        show={showArchiveSuccess}
        onHide={() => setShowArchiveSuccess(false)}
        className="text-center"
      >
        <Modal.Header closeButton>
          <h1 className="modal-title fs-5">Success</h1>
        </Modal.Header>
        <div className="text-center m-3"></div>
        <h4 className="text-center">Contacts archived successfully</h4>
        <div className="text-center m-3">
          <Button
            className="btn btn-primary"
            onClick={() => setShowArchiveSuccess(false)}
          >
            OK
          </Button>
        </div>
      </Modal>

      {/* unarchive */}
      <Modal
        size="md"
        show={showUnArchiveConfirm}
        onHide={() => setShowUnArchiveConfirm(false)}
        className="text-center"
      >
        <Modal.Header closeButton>
          <h1 className="modal-title fs-5">Unarchive Confirmation</h1>
        </Modal.Header>
        <div className="text-center m-3 text-danger"></div>
        <h4 className="text-center">
          Are you sure you want to unarchive these contacts?
        </h4>
        <div className="text-center m-3">
          <Button
            className="btn btn-primary m-1"
            onClick={() => setShowUnArchiveConfirm(false)}
          >
            Cancel
          </Button>
          <Button className="btn btn-primary m-1">
            UnArchive
          </Button>
        </div>
      </Modal>

      <Modal
        size="md"
        show={showUnArchiveSuccess}
        onHide={() => setShowUnArchiveSuccess(false)}
        className="text-center"
      >
        <Modal.Header closeButton>
          <h1 className="modal-title fs-5">Success</h1>
        </Modal.Header>
        <div className="text-center m-3"></div>
        <h4 className="text-center">Contacts unarchived successfully</h4>
        <div className="text-center m-3">
          <Button
            className="btn btn-primary"
            onClick={() => setShowUnArchiveSuccess(false)}
          >
            OK
          </Button>
        </div>
      </Modal>

      {/* //////////////////////////////// */}
      <Row>
        <Col lg={12}>
          <Sidebar
            visible={visibleViewRight}
            position="right"
            onHide={() => {
              setVisibleViewRight(false)
              setShowPassword(false)
            }}
            className="view-form-sidebar"
          >
            <div className="sidebar-header">
              <h3 className="head">
                <i className="pi pi-users"></i> Contact-{" "}
                {selectedCustomers.length > 0
                  ? fullNameTemplate(selectedCustomers[0])
                  : `${getValues("firstname") || ""} ${getValues("middlename") || ""
                    } ${getValues("lastname") || ""}`.trim()}{" "}
              </h3>
              <div className="d-flex align-items-center">
                <Button
                  icon="pi pi-times"
                  className="p-button-text close-btn"
                  onClick={() => setVisibleViewRight(false)}
                />
              </div>
            </div>
            <TabView className="mt-4">
              <TabPanel header="Profile" leftIcon="pi pi-user mr-2">
                <Row>
                  <Col lg={12}>
                    <Accordion activeIndex={0}>
                      <AccordionTab
                        header={
                          <span className="flex align-items-center gap-2 w-full">
                            <span className="white-space-nowrap">
                              PROFILE INFORMATION
                            </span>
                            <Badge value="-" className="ml-auto" />
                          </span>
                        }
                      >
                        <Row>
                          <Col lg={4}>
                            <div className="field">
                              <label htmlFor="firstname">Full Name</label>
                              <InputText
                                id="firstname"
                                value={`${getValues("firstname") || ""} ${getValues("middlename") || ""
                                  } ${getValues("lastname") || ""}`}
                                readOnly={!isEdited}
                                placeholder=""
                                className="w-full"
                              />
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div className="field">
                              <label htmlFor="email">Email</label>
                              <InputText
                                id="email"
                                type="email"
                                value={getValues("personal_email")}
                                readOnly={!isEdited}
                                placeholder=""
                                className="w-full"
                              />
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div className="field">
                              <label htmlFor="phone">Phone Number</label>
                              <InputText
                                id="phone"
                                type="tel"
                                value={getValues("Phone")}
                                readOnly={!isEdited}
                                placeholder=""
                                className="w-full"
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={4}>
                            <div className="field">
                              <label htmlFor="jobTitle">Job Title</label>
                              <InputText
                                id="jobTitle"
                                value={getValues("jobtitle")}
                                readOnly={!isEdited}
                                placeholder=""
                                className="w-full"
                              />
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div className="field">
                              <label htmlFor="company">Company</label>
                              <InputText
                                id="company"
                                value={
                                  getValues("company")
                                }
                                readOnly={!isEdited}
                                placeholder=""
                                className="w-full"
                              />
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div className="field">
                              <label htmlFor="department">Department</label>
                              <InputText
                                id="department"
                                value={getValues("department")}
                                readOnly={!isEdited}
                                placeholder=""
                                className="w-full"
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={4}>
                            <div className="field">
                              <label htmlFor="relatedPerson">
                                Related Person
                              </label>
                              <InputText
                                id="relatedPerson"
                                value={getValues("RelatedName")}
                                readOnly={!isEdited}
                                placeholder=""
                                className="w-full"
                              />
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div className="field">
                              <label htmlFor="jobType">Categories</label>
                              <InputText
                                value={categoriesItem}
                                readOnly={!isEdited}
                                placeholder=""
                                className="w-full"
                              />
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div className="field">
                              <label htmlFor="groups" className="block">
                                Groups
                              </label>
                              <InputText
                                value={groupItem}
                                readOnly={!isEdited}
                                placeholder=""
                                className="w-full"
                              />
                            </div>
                          </Col>
                        </Row>

                        <Row className="mb-2 d-flex align-items-end">
                          <Col lg={4}>
                            <div className="p-field">
                              <label htmlFor="userIds" className="block">
                                User IDs
                              </label>
                              <InputText
                                id="userIds"
                                value={uniqueUserId}
                                readOnly={!isEdited}
                                placeholder=""
                                className="block w-full"
                              />
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div className="p-field">
                              <label htmlFor="username">Username</label>
                              <InputText
                                id="username"
                                value={getValues("username")}
                                readOnly={!isEdited}
                                placeholder=""
                                className="w-full"
                              />
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div className="p-field">
                              <label htmlFor="password">Password</label>
                              <div className="p-inputgroup w-100">
                                <InputText
                                  id="password"
                                  type={showPassword ? "text" : "password"}
                                  value={getValues("password")}
                                  readOnly={!isEdited}
                                  placeholder=""
                                  className="w-full"
                                />
                                <Button
                                  icon={
                                    showPassword
                                      ? "pi pi-eye" : "pi pi-eye-slash"
                                  }
                                  className="p-button-text"
                                  type="button"
                                  onClick={() => setShowPassword(prev => !prev)}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row className="mb-2 d-flex align-items-end">
                          <Col lg={6}>
                            <div className="private">
                              <input
                                type="checkbox"
                                {...register("private", {})}
                                onKeyUp={() => {
                                  trigger("private")
                                }}
                                className="me-2"
                                disabled={!isEdited}
                              />
                              <label htmlFor="private" className="mb-2">
                                Private
                              </label>
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col lg={12}>
                            <div className="field">
                              <label htmlFor="address">Address</label>
                              <InputTextarea
                                id="address"
                                value={address}
                                //onChange={(e) => setAddress(e.target.value)}
                                placeholder=""
                                rows={5}
                                cols={30}
                                className="w-full"
                              />
                            </div>
                          </Col>
                          {/* <Col lg={12}>
                            <div className="p-field">
                              <label htmlFor="jobType" className="block">
                                Notes
                              </label>
                              <InputTextarea
                                autoResize
                                value={description}
                                readOnly={!isEdited}
                                // onChange={(e) => setDescription(e.target.value)}
                                rows={5}
                                cols={40}
                                placeholder=""
                                className="w-full "
                              />
                            </div>
                          </Col> */}
                        </Row>
                      </AccordionTab>
                      <AccordionTab
                        header={
                          <span className="flex align-items-center gap-2 w-full">
                            <span className="white-space-nowrap">
                              DOCUMENTS
                            </span>
                            <Badge value="-" className="ml-auto" />
                          </span>
                        }
                      >
                        <Row>
                          <Col lg={12}>
                            <div className="doc-table">
                              <DataTable
                                value={documents}
                                tableStyle={{ minWidth: "50rem" }}
                                dataKey="key"
                                paginator
                                rows={5}
                                rowsPerPageOptions={[5, 10, 25, 50]}
                                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                              >
                                <Column
                                  field="document_type"
                                  header="Document Type"
                                  expander
                                  body={rowData =>
                                    editableTemplate(rowData, "document_type")
                                  }
                                />
                                <Column
                                  field="document_subject"
                                  header="Document Subject"
                                  body={rowData =>
                                    editableTemplate(
                                      rowData,
                                      "document_subject"
                                    )
                                  }
                                />
                                <Column
                                  field="created_at"
                                  header="Applied Date & Time"
                                  body={rowData => (
                                    <span>{rowData.data.created_at}</span>
                                  )}
                                />
                                <Column
                                  field="attachments"
                                  header="Attachments"
                                  body={attachmentBodyTemplate}
                                  style={{ minWidth: "12rem" }}
                                />
                                <Column
                                  body={actionTemplate}
                                  header="Actions"
                                />
                              </DataTable>
                            </div>
                          </Col>
                        </Row>
                      </AccordionTab>
                    </Accordion>
                  </Col>
                </Row>
              </TabPanel>
              <TabPanel header="Pipeline" leftIcon="pi pi-cog mr-2">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="pipelinetabs">
                      {stages.length === 0 ? (
                        <p>Loading stages or no stages available...</p>
                      ) : (
                        <TabView
                          scrollable
                          style={{ maxWidth: "1200px", overflow: "hidden" }}
                        >
                          {stages?.map(stage => (
                            <TabPanel
                              key={stage}
                              header={
                                stage.charAt(0).toUpperCase() + stage.slice(1)
                              }
                              rightIcon={
                                <Badge
                                  value={stageCounts[stage] || 0}
                                  severity="success"
                                  className="ml-2"
                                />
                              }
                              leftIcon="pi pi-cog mr-1"
                            >
                              <div className="row">
                                <div className="col-lg-12">
                                  <section className="job-datatable-section">
                                    <div className="card1 mt-3 mb-4 actjobsumtable">
                                      <DataTable
                                        value={
                                          filteredPipelineData[stage] || []
                                        }
                                        lazy
                                        responsiveLayout="scroll"
                                        showGridlines
                                        paginator
                                        first={
                                          (pipelinePage - 1) * pipelineRows
                                        }
                                        rows={pipelineRows}
                                        rowsPerPageOptions={[5, 10, 25]}
                                        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                        currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                        totalRecords={stageCounts[stage] || 0}
                                        onPage={e => {
                                          setPipelineRows(e.rows)
                                          setPipelinePage(
                                            Math.floor(e.first / e.rows) + 1
                                          )
                                        }}
                                        onFilter={e =>
                                          handleFilterChange(stage, e.filters)
                                        }
                                        filters={
                                          pipelineFilters[stage] || initFilters
                                        }
                                        filterDisplay="row"
                                        globalFilterFields={[
                                          "status",
                                          "jobid",
                                          "job_title",
                                          "candidate",
                                          "contact",
                                          "company",
                                          "date_time",
                                          "user_id",
                                        ]}
                                        emptyMessage={`No ${stage} jobs found.`}
                                        selection={selectedJob[stage] || []}
                                        onSelectionChange={e =>
                                          handleSelection(stage, e.value)
                                        }
                                        // selectionMode="multiple"
                                        resizableColumns
                                        columnResizeMode="expand"
                                      >
                                        <Column
                                          field="status"
                                          header="Status"
                                          sortable
                                          filter
                                          style={{ minWidth: "10rem" }}
                                        />
                                        <Column
                                          field="jobid"
                                          header="Job ID"
                                          sortable
                                          filter
                                          style={{ minWidth: "10rem" }}
                                        />
                                        <Column
                                          field="job_title"
                                          header="Job Title"
                                          sortable
                                          filter
                                          style={{ minWidth: "10rem" }}
                                        />
                                        <Column
                                          field="candidate"
                                          header="Candidate"
                                          sortable
                                          filter
                                          style={{ minWidth: "10rem" }}
                                        />
                                        <Column
                                          field="contact"
                                          header="Contact"
                                          sortable
                                          filter
                                          style={{ minWidth: "10rem" }}
                                        />
                                        <Column
                                          field="company"
                                          header="Company"
                                          sortable
                                          filter
                                          style={{ minWidth: "10rem" }}
                                        />
                                        <Column
                                          field="date_time"
                                          header="Date & Time"
                                          sortable
                                          filter
                                          style={{ minWidth: "12rem" }}
                                        />
                                        <Column
                                          field="user_id"
                                          header="User ID"
                                          sortable
                                          filter
                                          style={{ minWidth: "10rem" }}
                                        />
                                      </DataTable>
                                    </div>
                                  </section>
                                </div>
                              </div>
                            </TabPanel>
                          ))}
                        </TabView>
                      )}
                    </div>
                  </div>
                </div>
              </TabPanel>
              <TabPanel header="Activities" leftIcon="pi pi-calendar mr-2">
                <Row>
                  <Col lg={12}>
                    <section className="job-datatable-section">
                      <div className="card1 mt-3 mb-4 actjobsumtable">
                        <DataTable
                          responsive
                          showGridlines
                          value={filteredActivities}
                          tableStyle={{
                            minWidth: "50rem",
                            borderRadius: "8px",
                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                          }}
                          paginator
                          lazy
                          rows={rowsPerPage}
                          first={(currentPage - 1) * rowsPerPage}
                          totalRecords={activityTotalRecords}
                          onPage={e => {
                            setRowsPerPage(e.rows)
                            setCurrentPage(e.page + 1)
                            fetchActivities(
                              selectedCustomers[0].id,
                              e.page + 1,
                              e.rows
                            )
                          }}
                          onFilter={e => setActivitiesFilters(e.filters)}
                          rowsPerPageOptions={[5, 10, 25, 50]}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          filters={activitiesFilters}
                          filterDisplay="row"
                          globalFilterFields={[
                            "event_type",
                            "event_sub_type",
                            "event_priority",
                            "subject",
                            "event_time",
                            "user_ids",
                          ]}
                          emptyMessage="No activities found."
                          selection={selectedActivities}
                          onSelectionChange={e =>
                            setSelectedActivities(e.value)
                          }
                          // selectionMode="multiple"
                          resizableColumns
                          columnResizeMode="expand"
                        >
                          {/* <Column selectionMode="multiple" headerStyle={{ width: "3em" }} /> */}
                          <Column
                            field="event_type"
                            header="Type"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="event_sub_type"
                            header="Sub-Type"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="event_priority"
                            header="Priority"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="subject"
                            header="Subject"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          {/* <Column field="action_date" body={(rowData) => rowData.action_date ? moment(rowData.created_at).format('DD/MM/YYYY') : ''} header="Action Date" sortable filter filterPlaceholder="Search by action date" style={{ minWidth: '10rem' }} /> */}
                          <Column
                            field="event_time"
                            header="Date and Time"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                            body={rowData =>
                              rowData.event_time
                                ? moment(rowData.event_time).format(
                                  "YYYY-MM-DD hh:mm A"
                                )
                                : ""
                            }
                          // body={(rowData) => {
                          //   const eventTime = rowData.event_time;
                          //   const dateOnly = eventTime.split("T")[0];
                          //   const timeOnly = eventTime.split("T")[1].slice(0, 5);
                          //   return `${dateOnly} ${timeOnly}`;
                          // }}
                          />
                          <Column
                            field="user_ids"
                            header="User ID"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                        </DataTable>
                      </div>
                    </section>
                  </Col>
                </Row>
              </TabPanel>
              <TabPanel header="History" leftIcon="pi pi-clock mr-2">
                <Row>
                  <Col lg={12} sm={12}>
                    <section className="job-datatable-section">
                      <div className="card1 mt-3 mb-4 actjobsumtable">
                        <DataTable
                          responsive
                          showGridlines
                          value={filteredHistory}
                          tableStyle={{
                            minWidth: "50rem",
                            borderRadius: "8px",
                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                          }}
                          paginator
                          lazy
                          rows={rowsPerPage1}
                          first={(currentPage1 - 1) * rowsPerPage1}
                          totalRecords={totalRecordss}
                          onPage={e => {
                            setRowsPerPage1(e.rows)
                            setCurrentPage1(e.page + 1)
                            fetchhistory(
                              selectedCustomers[0].id,
                              e.page + 1,
                              e.rows
                            )
                          }}
                          onFilter={e => setHistoryFilters(e.filters)}
                          rowsPerPageOptions={[5, 10, 25, 50]}
                          // onPage={onPageChangehistory}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          filters={historyFilters}
                          filterDisplay="row"
                          globalFilterFields={[
                            "type",
                            "sub_type",
                            "priority",
                            "subject",
                            "datetime",
                            "user_id",
                          ]}
                          emptyMessage="No history found."
                          selection={selectedHistory}
                          // onSelectionChange={(e) => setSelectedHistory(e.value)}
                          // selectionMode="multiple"
                          resizableColumns
                          columnResizeMode="expand"
                        >
                          {/* <Column selectionMode="multiple" headerStyle={{ width: "3em" }} /> */}
                          <Column
                            field="type"
                            header="Type"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="sub_type"
                            header="Sub Type"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="priority"
                            header="Priority"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="subject"
                            header="Subject"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="datetime"
                            header="Date and Time"
                            sortable
                            filter
                            body={rowData =>
                              rowData.datetime
                                ? moment
                                  .utc(rowData.datetime)
                                  .format("YYYY-MM-DD HH:mm a")
                                : ""
                            }
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="user_id"
                            header="User ID"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                        </DataTable>
                      </div>
                    </section>
                  </Col>
                </Row>
              </TabPanel>
              <TabPanel header="Notes" leftIcon="pi pi-pencil mr-2" className="nav-items">
                <Row>
                  <Col lg={12}>
                    <div className="d-flex justify-content-end">
                      <Button
                        type="button"
                        label="Add Notes"
                        icon="pi pi-plus"
                        className="btn btn-primary waves-light me-2 sidebarbtn"
                        onClick={handleAddNotes}
                      />
                    </div>
                  </Col>
                </Row>

                {isEditorVisible && (
                  <Row className="mt-4">
                    <Col lg={12}>
                      <Editor
                        value={editorContent}
                        onTextChange={e => setEditorContent(e.htmlValue)}
                        style={{ height: "200px" }}
                        placeholder="Enter your notes here..."
                      />
                      <div className="d-flex justify-content-end mt-2">
                        <Button
                          type="button"
                          label="Save"
                          icon="pi pi-save"
                          className="btn btn-success me-2"
                          onClick={handleSaveNotes}
                        />
                        <Button
                          color="primary"
                          className="btn btn-primary waves-light me-2 cancel-outlinebtn"
                          onClick={handleCancelNotes}
                        >
                          <i className="pi pi-times me-1"></i>
                          Cancel
                        </Button>
                      </div>
                    </Col>
                  </Row>
                )}

                <Row className="mt-4 notes">
                  <Col lg={12}>
                    {candidateNotes.length > 0 && (
                      <Card className="pt-0 pb-0">
                        {candidateNotes?.map((note, index) => (
                          <div key={index}>
                            <div className="d-flex mt-0">
                              <strong className="text-muted me-4">
                                Note: {note?.created_by_name}
                              </strong>
                              <strong className="text-muted">
                                Saved on:{" "}
                                {moment(note?.created_at).format(
                                  "YYYY-MM-DD hh:mm A"
                                )}
                              </strong>
                            </div>
                            <div className="d-flex justify-content-between mt-2 mb-0">
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: note.notes || note.content,
                                }}
                              />
                              <div>
                                <Button
                                  icon="pi pi-pencil"
                                  className="btn btn-warning editbtn p-0"
                                  onClick={() => handleEditNote(index)}
                                />
                                <Button
                                  icon="pi pi-trash"
                                  className="btn btn-danger deletebtn"
                                  onClick={() => handleDeleteNote(index)}
                                />
                              </div>
                            </div>
                            <hr />
                          </div>
                        ))}
                      </Card>
                    )}
                  </Col>
                </Row>
              </TabPanel>
            </TabView>
          </Sidebar>
        </Col>
      </Row>
      <>
        <div>
          {/* Interview schedule start */}

          <Dialog
            header={`Appointment - ${jobTitle || ""}`}
            visible={interviewpop}
            className="interview-popup"
            style={{ width: "50vw" }}
            onShow={resetDefaultDateTime}
            onHide={() => handleCancelInterview()}
          >
            <form onSubmit={handleSubmit1(onSubmitinterview)}>
              <p className="bg-form">
                <div className="mb-4">
                  <Row className="mb-2">
                    <Col xl={6}>
                      <div className="p-field flex flex-column">
                        <label htmlFor="interview">Type</label>
                        <InputText
                          disabled
                          value={intertype}
                          onChange={e => setintertype(e.target.value)}
                        />
                        {/* <Dropdown 
                          // disabled
                          value={intertype}
                          onChange={(e) => setintertype(e.target.value)}
                          options={interviewdroptype}
                          className="w-full search-option" /> */}
                      </div>
                    </Col>

                    <Col xl={6}>
                      <div className="p-field flex flex-column">
                        <label htmlFor="integer" className=" block">
                          Sub-Types
                        </label>
                        <Dropdown
                          value={subtype}
                          onChange={e => setSubtype(e.value)}
                          options={typeInterview}
                          optionLabel="label"
                          placeholder="Subtype"
                          className="w-full search-option"
                        />
                        {/* {newErrors.subtype && <div style={{ color: 'red' }}>{newErrors.subtype}</div>} */}
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col xl={6}>
                      <Row className="mb-2">
                        <Col xl={6}>
                          <div className="p-field flex-auto">
                            <label htmlFor="buttondisplay" className="block">
                              Start date
                            </label>
                            <Calendar
                              value={startdate}
                              onChange={e => setStartdate(e.value)}
                              showIcon
                              dateFormat="yy-mm-dd"
                            />
                            {newErrors.startdate && (
                              <div style={{ color: "red" }}>
                                {newErrors.startdate}
                              </div>
                            )}
                          </div>
                        </Col>

                        <Col xl={6}>
                          <div className="p-field flex-auto">
                            <label htmlFor="buttondisplay" className="block">
                              Time
                            </label>
                            <Calendar
                              value={starttime}
                              onChange={e => {
                                const selectedTime = e.value
                                setStarttime(selectedTime)

                                if (selectedTime) {
                                  const newEndTime = new Date(
                                    selectedTime.getTime() + 30 * 60000
                                  )
                                  setEndtime(newEndTime)
                                }
                              }}
                              showIcon
                              timeOnly
                              icon={() => <i className="pi pi-clock" />}
                            />
                            {/* <Calendar
                                value={starttime}
                                onChange={(e) => setStarttime(e.value)}
                                showIcon
                                timeOnly
                                icon={() => <i className="pi pi-clock" />}
                              /> */}
                            {newErrors.starttime && (
                              <div style={{ color: "red" }}>
                                {newErrors.starttime}
                              </div>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </Col>

                    <Col xl={6}>
                      <Row className="mb-2">
                        <Col xl={6}>
                          <div className="flex-auto">
                            <label htmlFor="buttondisplay" className="block">
                              End date
                            </label>
                            <Calendar
                              value={enddate}
                              onChange={e => {
                                if (startdate && e.value < startdate) {
                                  setNewErrors({ ...newErrors, enddate: "End date cannot be earlier than start date." })
                                } else {
                                  setEnddate(e.value)
                                  setNewErrors({ ...newErrors, enddate: null })
                                }
                              }}
                              showIcon
                              minDate={startdate}
                              dateFormat="yy-mm-dd"
                            />
                            {newErrors.enddate && (
                              <div style={{ color: "red" }}>
                                {newErrors.enddate}
                              </div>
                            )}
                          </div>
                        </Col>

                        <Col xl={6}>
                          <div className="flex-auto">
                            <label htmlFor="buttondisplay" className="block">
                              Time
                            </label>
                            <Calendar
                              value={endtime}
                              onChange={e => {
                                if (startdate && enddate && startdate.toDateString() === enddate.toDateString() && e.value < starttime) {
                                  setNewErrors({ ...newErrors, endtime: "End time cannot be earlier than start time on the same day." })
                                } else {
                                  setEndtime(e.value)
                                  setNewErrors({ ...newErrors, endtime: null })
                                }
                              }}
                              showIcon
                              timeOnly
                              icon={() => <i className="pi pi-clock" />}
                            // minDate={startdate && enddate && startdate.toDateString() === enddate.toDateString() ? startdate : null} // Restrict time only if same date
                            // minTime={startdate && enddate && startdate.toDateString() === enddate.toDateString() ? starttime : null} // Restrict end time to be >= start time
                            />

                            {newErrors.endtime && (
                              <div style={{ color: "red" }}>
                                {newErrors.endtime}
                              </div>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>

                <div className="mb-4">
                  <LinkContactJob1
                    selectedCustomers={selectedCustomers}
                    setsubtypeget={setsubtypeget}
                    setcontactvalu={setcontactvalu}
                    setNewErrors={setNewErrors}
                    newErrors={newErrors}
                  />

                  <Row className="mb-2">
                    <LinkCandidatesPopup1
                      setcondidatevalu={setcondidatevalu}
                      setNewErrors={setNewErrors}
                      newErrors={newErrors}
                    />

                    <Col xl={6}>
                      <div className="p-field flex flex-column">
                        <label htmlFor="username">Subject</label>
                        <InputText
                          placeholder="Subject"
                          value={subjectval}
                          onChange={e => setsubjectval(e.target.value)}
                        />
                        {/* {newErrors.subjectval && <div style={{ color: 'red' }}>{newErrors.subjectval}</div>} */}
                      </div>
                    </Col>
                  </Row>

                  <Row className="mb-2 mt-3">
                    <Col xl={12}>
                      <div className="">
                        <InputTextarea
                          className="w-full"
                          value={popTextares}
                          onChange={e => setPopTextares(e.target.value)}
                          placeholder="Interview Test"
                          rows={3}
                          cols={20}
                        />
                        {/* {newErrors.popTextares && <div style={{ color: 'red' }}>{newErrors.popTextares}</div>} */}
                      </div>
                    </Col>
                  </Row>
                </div>

                <div>
                  <Row className="mb-2">
                    {callingtask ? (
                      <>
                        <Col xl={4}>
                          <div className="p-field">
                            <label htmlFor="username">Auto Followup</label>
                            <Dropdown
                              value={followup}
                              onChange={e => setFollowup(e.value)}
                              options={followupOptions}
                              optionLabel="name"
                              placeholder="Select a Followup Interval"
                              className="w-full search-option"
                            />
                            {/* {newErrors.followup && <div style={{ color: 'red' }}>{newErrors.followup}</div>} */}
                          </div>
                        </Col>
                        <Col xl={4}>
                          <div className="p-field flex flex-column">
                            <label htmlFor="username">Repeat</label>
                            <Dropdown
                              value={repeat}
                              onChange={e => setRepeat(e.value)}
                              options={repeatOptions}
                              optionLabel="name"
                              placeholder="Select a Repeat Option"
                              className="w-full search-option"
                            />
                            {/* {newErrors.repeat && <div style={{ color: 'red' }}>{newErrors.repeat}</div>} */}
                          </div>
                        </Col>
                      </>
                    ) : (
                      ""
                    )}

                    <Col xl={4}>
                      <div className="p-field flex flex-column">
                        <div className="p-field">
                          <label htmlFor="reminder">Reminder</label>
                          <Dropdown
                            value={reminder}
                            onChange={e => setReminder(e.value)}
                            options={reminderOptions}
                            optionLabel="name"
                            placeholder="Select a Reminder"
                            className="w-full search-option"
                          />
                        </div>
                        {/* <Dropdown
                                value={reminder}
                                onChange={(e) => setReminder(e.value)}
                                options={reminderOptions}
                                optionLabel="name"
                                placeholder="Select a Reminder"
                                className="w-full search-option"
                              /> */}
                        {/* {newErrors.reminder && <div style={{ color: 'red' }}>{newErrors.reminder}</div>} */}
                      </div>
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col lg={6}>
                      <Row>
                        <Col xl={6}>
                          <div className="p-field flex flex-column">
                            <label For="Priority" className=" block">
                              Priority
                            </label>
                            <Dropdown
                              value={priority}
                              onChange={e => setPriority(e.value)}
                              options={priorityType}
                              optionLabel="name"
                              placeholder="Priority"
                              className="w-full search-option"
                            />
                            {/* {newErrors.priority && <div style={{ color: 'red' }}>{newErrors.priority}</div>} */}
                          </div>
                        </Col>
                        <Col xl={6}>
                          <Row className="mt-2">
                            <Col xl={6}>
                              <div className="d-flex align-items-center mt-4">
                                <Checkbox
                                  inputId="checkbox"
                                  checked={popchecked}
                                  onChange={handlePopupCheckbox}
                                />
                                <label htmlFor="username" className="ms-1 mt-2">
                                  Completed
                                </label>
                                {newErrors.popchecked && (
                                  <div style={{ color: "red" }}>
                                    {newErrors.popchecked}
                                  </div>
                                )}
                              </div>
                            </Col>

                            <Col xl={6}>
                              <div className="d-flex align-items-center mt-4">
                                <Checkbox
                                  inputId="checkbox"
                                  checked={popchecked2}
                                  onChange={handlePopupCheckbox2}
                                />
                                <label htmlFor="username" className="ms-1 mt-2">
                                  Private
                                </label>
                                {newErrors.popchecked2 && (
                                  <div style={{ color: "red" }}>
                                    {newErrors.popchecked2}
                                  </div>
                                )}
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                    <Col xl={6}>
                      <label htmlFor="username">User Id's</label>
                      <InputText
                        value={uniqueUserId}
                        readOnly
                        className="w-full"
                      />
                    </Col>
                  </Row>
                </div>

                <Row className="">
                  <Col xl={12}>
                    <div className="d-flex justify-content-end">
                      <button
                        type="submit"
                        class="btn btn-primary  waves-light btn btn-primary me-2 btn-main"
                      >
                        <i className="pi pi-save me-1"></i>
                        Save
                      </button>
                      <button
                        onClick={() => handleCancelInterview()}
                        color="primary"
                        type="button"
                        className="btn btn-primary  waves-light me-2 cancel-outlinebtn"
                      >
                        <i className="pi pi-times me-1"></i>
                        Cancel
                      </button>
                    </div>
                  </Col>
                </Row>
              </p>
            </form>
          </Dialog>
          <Dialog
            header="Warning"
            visible={warningDialogVisible}
            modal
            onHide={() => setWarningDialogVisible(false)}
            style={{ width: "30vw" }}
            className="modal-content"
          >
            <div className="p-3 text-center">
              {" "}
              {/* Added text-center for centering content */}
              <p>Please select at least one contact to proceed.</p>
              <div className="d-flex justify-content-center mt-4">
                {" "}
                {/* Changed justify-content-end to justify-content-center */}
                <Button
                  type="button"
                  label="OK"
                  className="btn btn-primary btn-main"
                  onClick={() => setWarningDialogVisible(false)}
                />
              </div>
            </div>
          </Dialog>

          {/* Interview schedule end */}
        </div>
      </>
    </React.Fragment>
  )
}
export default ContactsAllActive
